import React, { Component } from 'react';
import $ from "jquery";
import { ApiClient } from "../libs/apiClient";
import { ListPartnerModal, MercanciaPorteModal, AddressesPorteModal, ClaveProdModal, WarningModal } from '../components';
import { AddressesPartnerModal, } from "./index";
import { Datos_Empresa, SERVICE_RESPONSE, CURRENCY } from '../libs/utils/Const';
import { CartaPorte, Mercancia, UbicacionPorte, ConceptoPorte } from '../components/NewOrder';
import download from 'js-file-download';
import CancelCFDI from './CancelCFDI';
import { changeTipoFigura } from '../libs/utils/GlobalFunc';

const apiClient = ApiClient.getInstance();
const formatNumber = {
    separador: ',', // separador para los miles
    sepDecimal: '.', // separador para los decimales
    formatear: function (num) {
        num += '';
        let splitStr = num.split('.');
        let splitLeft = splitStr[0];
        let splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
        let regx = /(\d+)(\d{3})/;
        while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, '$1' + this.separador + '$2');
        }
        return this.simbol + splitLeft + splitRight;
    },
    new: function (num, simbol) {
        this.simbol = simbol || '';
        if (typeof num == 'undefined') {
            num = 0;
        }
        if (isNaN(num)) {
            return num;
        }
        return this.formatear(Number(num).toFixed(2));
    },
};


class CartaPorteModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editMode: false,
            partners: [],
            partnerType: null,
            pageTotal: 0,
            Codigo: '',
            invoices: [],
            checkboxArray: (new Map()),
            modalView: '',
            autotransporte: [],
            figuraTransporte: [],
            unidadPeso: [],
            itemModel: {},
            addressModel: {},
            flagAddressesPorteModal: false,
            states: [],
            municipios: [],
            localidades: [],
            colonias: [],
            UnidadConcepts: [],
            SearchModalModel: {
                Clave: '',
                Description: ''
            },
            ClaveProdByKey: [],
            auxiliarIndexLine: '',
            addresses: [],
            outStockTransfersDocs: [],
            arrayEntriesChoose: [],
            isCancelCFDI: false,
            recoveryModel: {},
            showWarningModal: false,
            warningModel: {},

            selectAction: () => { },
            transportes: [],
            figurasTransporte: [],

            // Carta porte de uso interno
            usoInternoAuthorized: false,
            usoInterno: false,
            typeCve: 0,
            SAPSearch: false,
        };

        this.newModelCopy = '';
    }
    //#region COMPONENT CYCLES
    componentDidMount = () => {
        this._handelBack();
        this.searchStatesCatalog();
        this.searchCartaPorteInfoCatalogs();
        this.ChangeCartaPorteType(this.props.model.TypeDoc);
    }

    _handelBack = () => {
        window.location.hash = "no-back-button";
        window.location.hash = "Again-No-back-button";
        window.onhashchange = function () { window.location.hash = "no-back-button"; }
    }
    //#endregion

    //#region CATÁLOGOS SAT
    searchCartaPorteInfoCatalogs = async () => {
        await this.callCartaPorteInfoCatalogs();
    };

    callCartaPorteInfoCatalogs = async () => {
        const { enableSpinner } = this.props;
        enableSpinner(true);
        let infoPorteCatalogsResponse = await apiClient.getCartaPorteInfoCatalogs();
        enableSpinner(false);
        // const filterUnidadConcepts = infoPorteCatalogsResponse?.data?.unidadPeso.filter((element) => Number(element.Simbolo) === 1);

        if (infoPorteCatalogsResponse.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                figuraTransporte: infoPorteCatalogsResponse.data.figuraTransporte,
                autotransporte: infoPorteCatalogsResponse.data.autotransporte,
                unidadPeso: infoPorteCatalogsResponse.data.unidadPeso,
                UnidadConcepts: infoPorteCatalogsResponse.data?.unidadPesoConcepts ?? [],
            });
        }
    };
    //#endregion

    //#region GENERAL FUNCTIONS 
    restartTabs = () => {
        $('#nav-CartaPorte-Mercancias').removeClass('active');
        $('#nav-CartaPorte-Conceptos').removeClass('active');
        $('#nav-CartaPorte-Transporte').removeClass('active');
        $('#nav-CartaPorte-FiguraTransporte').removeClass('active');
        $('#nav-CartaPorte-Ubicaciones').removeClass('active');
        $('#nav-CartaPorte-CFDIRelacionados').removeClass('active');

        $('#nav-CartaPorte-Mercancias').removeClass('nav-link-current');
        $('#nav-CartaPorte-Conceptos').removeClass('nav-link-current');
        $('#nav-CartaPorte-Transporte').removeClass('nav-link-current');
        $('#nav-CartaPorte-FiguraTransporte').removeClass('nav-link-current');
        $('#nav-CartaPorte-Ubicaciones').removeClass('nav-link-current');
        $('#nav-CartaPorte-CFDIRelacionados').removeClass('nav-link-current');

        $('#Section-CartaPorte-Mercancias').removeClass('active');
        $('#Section-CartaPorte-Conceptos').removeClass('active');
        $('#Section-CartaPorte-Transporte').removeClass('active');
        $('#Section-CartaPorte-FiguraTransporte').removeClass('active');
        $('#Section-CartaPorte-Ubicaciones').removeClass('active');
        $('#Section-CartaPorte-CFDIRelacionados').removeClass('active');

        $('#Section-CartaPorte-Mercancias').removeClass('show');
        $('#Section-CartaPorte-Conceptos').removeClass('show');
        $('#Section-CartaPorte-Transporte').removeClass('show');
        $('#Section-CartaPorte-FiguraTransporte').removeClass('show');
        $('#Section-CartaPorte-Ubicaciones').removeClass('show');
        $('#Section-CartaPorte-CFDIRelacionados').removeClass('show');

        $('#nav-CartaPorte-Mercancias').addClass('active');
        $('#nav-CartaPorte-Mercancias').addClass('nav-link-current');
        $('#Section-CartaPorte-Mercancias').addClass('active');
        $('#Section-CartaPorte-Mercancias').addClass('show');
    };

    closeModal = async () => {
        $('#CartaPorte').modal('hide');
        this.openCloseWarningModal(false)
        this.refreshModel(new CartaPorte());
        this.restartTabs();
        this.CleanEntriesChoose();
        await this.setState({
            isCancelCFDI: false,
            selectAction: () => { },
            transportes: [],
            figurasTransporte: [],
        })
    }

    CleanEntriesChoose = () => {
        this.setState({
            arrayEntriesChoose: []
        })
    }

    ChangeCartaPorteType = async (value) => {
        const { model } = this.props;
        const { usoInterno } = this.state;
        model.TypeDoc = value;
        if (value === 'I') {
            await this.AjustarCartaPorteIngreso();
        } else {
            await this.AjustarCartaPorteTraslado();
            if (usoInterno) {
                model.CardCode = "";
                model.CardName = "";
                model.LicTradNum = "";
                model.ZipCode = "";
                model.ZipCode = "";
                model.U_FMB_REGIMEN_FISCAL = "";
                model.U_FMB_METODO_PAGO = "";
            }
        }
        this.refreshModel(model);
    }

    ChangeSubTypeTransferDoc = async (value) => {
        const { model } = this.props;
        model.SubTypeTransferDoc = value;
        this.refreshModel(model);
    }

    AjustarCartaPorteIngreso = async () => {
        const { model, } = this.props
        // BLOQUEAR CAMPOS
        this.ValidateConceptFieldsEntrance();
    }

    ValidateConceptFieldsEntrance = async () => {
        const { model } = this.props
        if (model.Concepts && model.Concepts.length > 0) {
            let auxArrayConcepts = model.Concepts;
            for (let x = 0; x < auxArrayConcepts.length; x++) {
                let concept = auxArrayConcepts[x];
                concept.ObjetoImp = '01';
            }
            model.Concepts = auxArrayConcepts;
            this.refreshModel(model);
        }
    }

    AjustarCartaPorteTraslado = async () => {
        const { model } = this.props
        model.Concepts = [];
        for (let i = 0; i < model.Ubicaciones?.length || 0; i++) {
            model.Ubicaciones[i].RFCRemitenteDestinatario = Datos_Empresa.RFC;
            model.Ubicaciones[i].NombreRemitenteDestinatario = Datos_Empresa.Nombre;
        }
        this.refreshModel(model)
    }


    //#endregion

    //#region CRUD
    sendModel = () => {
        const { sendModel, model } = this.props;
        if (this.validateModel()) {
            sendModel(model);
        }
    };

    deleteModel = () => {
        const { deleteModel, model } = this.props;
        deleteModel(model.CodigoCarta);
        this.openCloseWarningModal(false);
        // $('#confirmModalCartaPorte').modal('show');
    };

    acceptEditMode = () => {
        const { acceptEditMode, model } = this.props;
        this.openCloseWarningModal(false)
        if (this.validateModel()) {
            acceptEditMode(model);
        }
    };

    cancelEditMode = () => {
        const { cancelEditMode } = this.props;
        const { recoveryModel } = this.state;
        this.openCloseWarningModal(false)
        cancelEditMode(recoveryModel);
        this.setState({
            editMode: false,
        });
    };

    editMode = () => {
        const { model } = this.props;
        this.setState({
            editMode: !this.state.editMode,
            recoveryModel: JSON.parse(JSON.stringify(model))
        });
    };
    //#endregion

    //#region Validar Timbrado para editar
    validateEditMode = () => {
        const { model } = this.props;
        if (model.U_FMB_UUID) {
            this.setState({
                warningModel: {
                    message: 'Este documento ha sido timbrado. Ha pasado por un proceso de validación y certificación.\nCualquier modificación realizada a este documento requerirá la cancelación del timbre  y la emisión de uno nuevo con las modificaciones realizadas.\n\n¿Estas seguro que deseas editar el documento?',
                    acceptMessage: 'Continuar',
                    acceptAction: this.editMode,
                }
            });
            this.openCloseWarningModal(true);
        } else { this.editMode(); }
    }

    validateDeleteMode = () => {
        const { model, showAlert } = this.props;
        if (model.U_FMB_UUID) {
            if (model.CanceledCFDI && model.CanceledCFDI === 'Y') {
                this.setState({
                    warningModel: {
                        message: 'La eliminación de esta Carta Porte es una acción irreversible, le recomendamos que verifique que su estatus sea cancelado ante el SAT. ¿Esta seguro que desea eliminarla?',
                        acceptMessage: 'Eliminar',
                        acceptAction: this.deleteModel,
                    }
                });
            } else {
                showAlert({ type: 'warning', message: 'Este documento se encuentra actualmente timbrado, por favor solicite la cancelación y vuelva a intentarlo' });
                return;
            }
        } else {
            this.setState({
                warningModel: {
                    message: 'La eliminación de esta Carta Porte es una acción irreversible, ¿Esta seguro que desea eliminarla?',
                    acceptMessage: 'Eliminar',
                    acceptAction: this.deleteModel,
                }
            });
        }
        this.openCloseWarningModal(true);
    }

    openCloseWarningModal = async (status) => {
        await this.setState({ showWarningModal: status });
        if (status) { $('#warningModal').modal('show'); }
        else { $('#warningModal').modal('hide'); }
    }
    //#endregion

    //#region FieldModel
    changeFieldModel = async (model, key, event) => {
        const value = event.nativeEvent.target.value;
        if (key === "ZipCode" && (isNaN(value) || value.length > 5)) return;
        model[key] = value;
        this.refreshModel(model);
    };

    ChangeVersionCartaPorte = async (value) => {
        const { model } = this.props
        // model
        model.Version = value
        this.refreshModel(model);
    }

    ChangeTranspInternac = async (value) => {
        const { model } = this.props
        // model
        model.TranspInternac = value
        this.refreshModel(model);
    }

    ChangeMotivoRelacion = async (value) => {
        const { model } = this.props
        // model
        model.MotivoRelacion = value
        this.refreshModel(model);
    }

    AddCFDIRelacionado = async () => {
        const { model } = this.props
        // model
        let auxArrayCFDI = model.CFDI_Relacionados;
        auxArrayCFDI.push('');
        model.CFDI_Relacionados = auxArrayCFDI;
        this.refreshModel(model);
    }

    ChangeCFDIValueInArray = async (target, value) => {
        const { model } = this.props

        let auxArrayCFDI = model.CFDI_Relacionados;
        auxArrayCFDI[target] = value;
        model.CFDI_Relacionados = auxArrayCFDI;
        this.refreshModel(model);
    }

    DeleteCFDIByIndex = async (target) => {
        const { model } = this.props
        let auxArrayCFDI = model.CFDI_Relacionados;
        auxArrayCFDI.splice(target, 1); // 1 es la cantidad de elemento a eliminar
        model.CFDI_Relacionados = auxArrayCFDI;
        this.refreshModel(model);
    }


    // Funcion para validar campos requeridos *o*
    validateModel = () => {
        const { model, showAlert, action } = this.props;
        const { usoInterno } = this.state;

        if (model.TypeDoc === '') {
            showAlert({ type: 'warning', message: 'Selecciona el tipo de carta porte que necesitas' });
            return false;
        }
        const flagTypeTraslado = model.TypeDoc === 'T' ? true : false;
        // console.log('con<model', model);
        if (!flagTypeTraslado && (model.CardCode === '' || model.CardName === undefined || model.CardName === '')) {
            showAlert({ type: 'warning', message: 'Selecciona un socio de negocios' });
            return false;
        }
        if (flagTypeTraslado && (model.CardName === undefined || model.CardName === '') && (!!model.CardCode && model.CardCode !== '')) {
            showAlert({ type: 'warning', message: 'Código de cliente invalido, por favor ingrese un cliente valido o deje vació el campo' });
            return false;
        }
        if (model.TranspInternac === undefined || model.TranspInternac === '') {
            showAlert({ type: 'warning', message: 'El campo TranspInternac no puede estar vacío' });
            return false;
        }
        if (model.TranspInternac === 'Sí' && (model.EntradaSalidaMerc === undefined || model.EntradaSalidaMerc === '')) {
            showAlert({ type: 'warning', message: 'El campo EntradaSalidaMerc no puede estar vacío' });
            return false;
        }
        if (model.TranspInternac === 'Sí' && (model.PaisOrigenDestino === undefined || model.PaisOrigenDestino === '')) {
            showAlert({ type: 'warning', message: 'El campo PaisOrigenDestino no puede estar vacío' });
            return false;
        }
        if (model.TranspInternac === 'Sí' && (model.ViaEntradaSalida === undefined || model.ViaEntradaSalida === '')) {
            showAlert({ type: 'warning', message: 'El campo ViaEntradaSalida no puede estar vacío' });
            return false;
        }
        if (model.Mercancias.length > 0) {
            for (let index = 0; index < model.Mercancias.length; index++) {
                const lines = model.Mercancias[index];
                if (lines.Cantidad === '' || lines.ValorMercancia === 0.00) {
                    showAlert({ type: 'warning', message: 'Es necesario agregar Mercancías para poder continuar con la creación del documento' });
                    return false;
                }
            }
        }

        if (model.TypeDoc === 'I') {
            if (model.Concepts.length === 0) {
                showAlert({ type: 'warning', message: 'Es necesario agregar Conceptos para poder continuar con la creación del documento' });
                return false;
            }

            if (model.Concepts.length > 0) {
                for (let index = 0; index < model.Concepts.length; index++) {
                    const concept = model.Concepts[index];
                    const auxLine = index + 1
                    if (concept.Cantidad === '' || Number(concept.Cantidad) === 0) {
                        showAlert({ type: 'warning', message: `Debes de agregar cantidad en superior a 0 en el concepto linea ${auxLine}` });
                        return false;
                    }
                    if (concept.ClaveProdServ === '' || Number(concept.ClaveProdServ) === 0) {
                        showAlert({ type: 'warning', message: `Debes de la agregar la CLAVE UNIDAD SAT en el concepto linea ${auxLine}` });
                        return false;
                    }
                    if (concept.Descripcion === '' || Number(concept.Descripcion) === 0) {
                        showAlert({ type: 'warning', message: `Debes de agregar la descripción del concepto en la linea ${auxLine}` });
                        return false;
                    }
                    if (concept.ValorUnitario === '' || Number(concept.ValorUnitario) === 0) {
                        showAlert({ type: 'warning', message: `Debes de agregar el precio unitario superior a 0 en el concepto linea ${auxLine}` });
                        return false;
                    }
                }
            }
        }


        model.TotalDistRec = 0;
        if (model.Ubicaciones.length > 0) {
            for (let index = 0; index < model.Ubicaciones.length; index++) {
                const ubications = model.Ubicaciones[index];
                if (ubications.TipoUbicacion === 'Destino') {
                    model.TotalDistRec += Number(ubications.DistanciaRecorrida || 0);
                }
                if ((ubications.DistanciaRecorrida === '' || ubications.DistanciaRecorrida === '0' || ubications.DistanciaRecorrida === 0.00) && ubications.TipoUbicacion === 'Destino') {
                    showAlert({ type: 'warning', message: 'Es necesario agregar DistanciaRecorrida en el apartado de UBICACIONES > "VER DETALLES" en la ubicación de ' + ubications.TipoUbicacion || '', timeOut: 50000 });
                    return false;
                }
                if (ubications.CodigoPostal === '') {
                    showAlert({ type: 'warning', message: 'Es necesario agregar CodigoPostal en la ubicación de ' + ubications.TipoUbicacion || '' });
                    return false;
                }
                if (ubications.Estado === '') {
                    showAlert({ type: 'warning', message: 'Es necesario agregar Estado en la ubicación de ' + ubications.TipoUbicacion || '' });
                    return false;
                }
            }
        }
        if (model.TotalDistRec === 0 || model.TotalDistRec === undefined || model.TotalDistRec === '') {
            showAlert({ type: 'warning', message: 'El campo TotalDistRec no puede estar vacío' });
            return false;
        }
        if (model.UsoCFDI === '') {
            showAlert({ type: 'warning', message: 'El campo Uso de CFDI no puede estar vacío' });
            return false;
        }

        if (model.TranspInternac === undefined || model.TranspInternac === '') {
            showAlert({ type: 'warning', message: 'Debes de indicar si la mercancia sale del país' });
            return false;
        }
        if (Number(action) === 1 && !flagTypeTraslado && Number(model.TotalFlete) === 0) {
            showAlert({ type: 'warning', message: 'Debes de indicar el total de la factura del flete del cliente en la cabecera del documento carta porte' });
            return false;
        }

        // const cpRegex = /[0-9]{5}/;
        // if (usoInterno && !cpRegex.test(model.ZipCode)) {
        //     showAlert({ type: 'warning', message: 'Ingrese un código postal valido' });
        //     return false;
        // }


        return true;
    };

    refreshModel = model => {
        const { usoInterno } = this.state;
        const { refreshModel } = this.props;
        if (usoInterno) {
            if (model.Mercancias.length > 0) {
                let brutoTotal = 0;
                let netoTotal = 0;
                for (let i = 0; i < model.Mercancias.length; i++) {
                    netoTotal += Number(model.Mercancias[i].PesoNeto || '0') * Number(model.Mercancias[i].Cantidad || '0');
                    brutoTotal += Number(model.Mercancias[i].PesoBruto || '0') * Number(model.Mercancias[i].Cantidad || '0');
                }
                model.PesoBrutoTotal = brutoTotal;
                model.PesoNetoTotal = netoTotal;
                model.NumTotalMercancias = model.Mercancias.length;
            }
        }
        refreshModel(model);
    };
    //#endregion

    //#region SelectPartner
    refreshPartner = async (partner, totalPage) => {
        this.setState({
            partners: partner,
            pageTotal: totalPage
        });
    };

    openPartner = async () => {
        const { usoInterno } = this.state;
        const { model, enableSpinner, showAlert } = this.props;
        let type = 'C';
        enableSpinner(true);
        let getPartnerResponse = null;
        let CardCode = model.CardCode || '';
        await apiClient.getPartnerListCreate(type, CardCode, 1).then(valor => {
            getPartnerResponse = valor;
        });
        enableSpinner(false);
        if (!Array.isArray(getPartnerResponse.data.results)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }
        if (getPartnerResponse.data.results.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }
        if (getPartnerResponse.data.results.length === 1) {
            if (usoInterno) {
                await this.selectSAPClient(getPartnerResponse.data.results[0]);
                this.restartTabs();
                return;
            }

            model.CardCode = getPartnerResponse.data.results[0].CardCode;
            model.CardName = getPartnerResponse.data.results[0].CardName;
            this.refreshModel(model);
            this.restartTabs();
            return;
        }
        this.setState({
            modalView: 'P',
            partners: getPartnerResponse.data.results,
            partnerType: type,
            pageTotal: getPartnerResponse.data.totalPage,
        });
        $('#partnerList').modal('show');
    };

    selectPartner = async action => {
        const { partners, usoInterno } = this.state;
        let { model, view, enableSpinner, showAlert } = this.props;
        let partner = partners[action.index];
        if (usoInterno) {
            await this.selectSAPClient(partner);
            return;
        }
        if (partner.validFor === 'N') {
            showAlert({ type: 'error', message: 'El socio de negocio se encuentra inactivo' });
            this.restartTabs();
            setTimeout(() => {
                this.setState({ partners: [] });
            }, 100);
            return;
        }
        try {
            model.CardCode = partner.CardCode;
            model.CardName = partner.CardName;
            $('#partnerList').modal('hide');
            this.restartTabs();
            setTimeout(() => {
                this.setState({ partners: [] });
            }, 100);
        } catch {
            showAlert({ type: 'warning', message: 'Información de socio incompleta, porfavor contacta a tu administrador del sistema' });
            $('#partnerList').modal('hide');
            this.restartTabs();
            setTimeout(() => {
                this.setState({ partners: [] });
            }, 100);
        }
    };
    //#endregion

    //#region Invoice
    selectItems = async (Items, arg) => {
        const { model } = this.props;
        let arrayModel = model.Mercancias ?? []; // aqui me quede 
        let PesoBrutoTotal = 0;
        // console.log('con<,,,,,,,,,,,,,,,,', Items.Length, arg);
        //#region Add Ubication Origen
        let addUbicationsOrigin = {
            TipoUbicacion: 'Origen',
            RFCRemitenteDestinatario: Datos_Empresa.RFC,
            NombreRemitenteDestinatario: Datos_Empresa.Nombre,
            Calle: `${Datos_Empresa.Calle}, COL. ${Datos_Empresa.Colonia}`,
            NumeroExterior: '660',
            Estado: 'SIN',
            Localidad: '02',
            Pais: 'MEX',
            Municipio: '006',
            CodigoPostal: Datos_Empresa.CP,
            DocEntry: '55',
        }
        let flagOrigin = model.Ubicaciones.find((ubications) => ubications.TipoUbicacion === 'Origen' && ubications.DocEntry === '55');

        if (!flagOrigin) {
            model.Ubicaciones.push(addUbicationsOrigin)
        }
        //#endregion
        for (let i = 0; i < Items.length; i++) {
            let itemModel = new Mercancia();
            itemModel.update = 1;
            itemModel.Index = Items[i].Index;
            itemModel.LineNum = Items[i].LineNum;
            itemModel.claveProdServ = Items[i].U_FMB_CLAVE_SAT;
            itemModel.BienesTransp = Items[i].U_FMB_CLAVE_SAT;
            // cartaporte20:Mercancias:Mercancia
            itemModel.Descripcion = Items[i].Dscription;
            itemModel.Cantidad = Items[i].Quantity;
            itemModel.HomeQuantity = Items[i].Quantity;
            itemModel.ClaveUnidad = Items[i].unitMsr;
            itemModel.Unidad = Items[i].unitMsr;
            itemModel.Dimensiones = Number(Items[i].Height1 || 0) + '/' + Number(Items[i].Width1 || 0) + '/' + Number(Items[i].Length1 || 0)
            itemModel.PesoEnKg = Number(Items[i].BWeight1);
            itemModel.ValorMercancia = Items[i].PriceBefDi;
            itemModel.Moneda = Items[i].Currency;
            itemModel.NumAtCard = Items[i].NumAtCard;
            itemModel.DocEntry = Items[i].DocEntry;
            itemModel.ItemCode = Items[i].ItemCode;
            arrayModel.push(itemModel);

            PesoBrutoTotal += Number(Items[i].BWeight1);
            // NumTotalMercancias += Number(Items[i].Quantity);

            // model.Ubicaciones[1].TipoUbicacion = 'Destino';
            // model.Ubicaciones[1].RFCRemitenteDestinatario = Items[i].LicTradNum || '';
            // model.Ubicaciones[1].Calle = Items[i].Street || '';
            // model.Ubicaciones[1].NumeroExterior = Items[i].StreetNo || '';
            // model.Ubicaciones[1].Estado = Items[i].State || '';
            // model.Ubicaciones[1].Pais = (Items[i].Country == 'MX') ? 'MEX' : Items[i].Country;
            // model.Ubicaciones[1].CodigoPostal = Items[i].ZipCode || '';

            //#region Add Ubication Destino
            let flagDetination = model.Ubicaciones.find((ubications) => ubications.DocEntry === Items[i].DocEntry);

            if (!flagDetination) {
                let addUbications = {
                    TipoUbicacion: 'Destino',
                    RFCRemitenteDestinatario: Items[i].LicTradNum ? Items[i].LicTradNum : Items[i].LicTradNum_2 || '',
                    NombreRemitenteDestinatario: Items[i].CardName ? Items[i].CardName : '',
                    DistanciaRecorrida: 0,
                    Calle: Items[i].Street ? Items[i].Street : Items[i].Street_2 || '',
                    NumeroExterior: Items[i].StreetNo ? Items[i].StreetNo : Items[i].StreetNo_2 || '',
                    Estado: Items[i].State ? Items[i].State : Items[i].State_2 || Items[i].c_Estado,
                    Pais: Items[i].Country ? ((Items[i].Country == 'MX') ? 'MEX' : Items[i].Country) : ((Items[i].Country_2 == 'MX') ? 'MEX' : Items[i].Country_2),
                    CodigoPostal: Items[i].ZipCode ? Items[i].ZipCode : Items[i].ZipCode_2 || '',
                    DocEntry: Items[i].DocEntry || '',
                }
                if (model.TypeDoc !== 'I') {
                    addUbications = {
                        TipoUbicacion: 'Destino',
                        RFCRemitenteDestinatario: Datos_Empresa.RFC,
                        NombreRemitenteDestinatario: Datos_Empresa.Nombre,
                        DistanciaRecorrida: 0,
                        Calle: `${Datos_Empresa.Calle}, COL. ${Datos_Empresa.Colonia}`,
                        NumeroExterior: '660',
                        Estado: 'SIN',
                        Localidad: '02',
                        Pais: 'MEX',
                        Municipio: '006',
                        CodigoPostal: Datos_Empresa.CP,
                        DocEntry: Items[i].DocEntry || '',
                    }
                }
                model.Ubicaciones.push(addUbications)
            }
            //#endregion
        }
        // LLena la ubicación de Origen (EMPRESA) por default (SE SUPONE NO CAMBIA)
        // model.Ubicaciones[0].TipoUbicacion = 'Origen';
        // model.Ubicaciones[0].RFCRemitenteDestinatario = Datos_Empresa.RFC;
        // model.Ubicaciones[0].NombreRemitenteDestinatario = Datos_Empresa.Nombre;
        // model.Ubicaciones[0].Calle = `${Datos_Empresa.Calle}, COL. ${Datos_Empresa.Colonia}`;
        // model.Ubicaciones[0].NumeroExterior = '660';
        // model.Ubicaciones[0].Estado = 'SIN';
        // model.Ubicaciones[0].Localidad = '02';
        // model.Ubicaciones[0].Pais = 'MEX';
        // model.Ubicaciones[0].Municipio = '006';
        // model.Ubicaciones[0].CodigoPostal = Datos_Empresa.CP;
        model.Mercancias = arrayModel;
        model.DocEntry = arg !== undefined ? arg.DocEntry.toString() : '';
        model.DocNum = arg !== undefined ? arg.DocNum.toString() : '';
        model.PesoBrutoTotal = parseFloat(PesoBrutoTotal).toFixed(3);
        // console.log('con<NumTotalMercancias', NumTotalMercancias);
        // model.NumTotalMercancias = parseFloat(NumTotalMercancias).toFixed(3);
        model.NumTotalMercancias = arrayModel.length ?? 0;

        this.setState({
            checkboxArray: Items,
        })
    };

    selectItemsToArray = async () => {
        const { enableSpinner } = this.props;
        const { checkboxArray, modalView, invoices, partners, outStockTransfersDocs, arrayEntriesChoose } = this.state;
        let items = [];
        let invoiceList = [];
        let arg = {};
        let data = (modalView === 'I') ? invoices : (modalView === 'outStockTransfersDocs') ? outStockTransfersDocs : partners;
        for (let [id, value] of checkboxArray.entries()) {
            if (value) {
                arg = {
                    DocNum: data[id].DocNum,
                    DocEntry: data[id].DocEntry,
                    action: modalView === 'outStockTransfersDocs' ? 'getOutStockTransfersLines' : 'getInvoicesLines'
                }

                enableSpinner(true);
                invoiceList = await apiClient.getInvoicesPorte(arg);
                enableSpinner(false);

                for (let [id, value] of invoiceList.data.entries()) {
                    if (value && Number(value.Quantity) > 0) {
                        value.Index = id;
                        items.push(value);
                    }
                }
                let auxArrayEntriesChoose = arrayEntriesChoose;
                auxArrayEntriesChoose.push(data[id].DocEntry);
                this.setState({
                    arrayEntriesChoose: auxArrayEntriesChoose
                })
            }
        }
        this.selectItems(items, arg);
        $('#partnerList').modal('hide');
    };

    ReturnTransferAction = () => {
        const { model, _user } = this.props;
        let auxObject = {
            returnAction: '',
            searchParam: '',
        }
        switch (model.SubTypeTransferDoc) {
            case 'S':
                auxObject.returnAction = 'getOutStockTransfersDocs';
                auxObject.searchParam = _user.Branch.ProjectCode;
                break;
            case 'C':
                auxObject.returnAction = 'getCEDISStockTransfersDocs';
                auxObject.searchParam = '';
                break;
            case 'D':
                auxObject.returnAction = 'getStraightStockTransfersDocs';
                auxObject.searchParam = _user.Branch.ProjectCode;
                break;

            default:
                auxObject.returnAction = '';
                auxObject.searchParam = '';
                break;
        }

        return auxObject
    }

    openInvoicePaymentList = async () => {
        const { model, showAlert, enableSpinner, } = this.props;
        const { arrayEntriesChoose } = this.state

        if (model.TypeDoc === '') {
            showAlert({ type: 'info', message: 'Selecciona el tipo de Carta Porte que necesitas' });
            return;
        }
        if (model.TypeDoc === 'I') { // document type "Ingreso"
            if (model.CardCode === '') {
                showAlert({ type: 'info', message: 'Selecciona un socio de negocios' });
                return;
            }
            const data = {
                DocEntry: model.CardCode,
                action: 'getInvoicesHeader'
            }
            enableSpinner(true);
            const invoiceList = await apiClient.getInvoicesPorte(data);
            enableSpinner(false);

            if (!Array.isArray(invoiceList.data)) {
                showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
                return;
            }
            if (invoiceList.data.length === 0) {
                showAlert({ type: 'info', message: 'No hay información por mostrar' });
                return;
            }
            const filteredData = await this.CheckIfWasEntrySelected(invoiceList.data, arrayEntriesChoose);

            this.setState({
                modalView: 'I',
                invoices: filteredData,
            });
            if (filteredData.length > 0) {
                $('#partnerList').modal('show');
            } else {
                showAlert({ type: 'info', message: 'No hay información por mostrar' });
            }

        } else { // document type "Traslado"
            const actionTransfer = await this.ReturnTransferAction();
            const data = {
                action: actionTransfer.returnAction,
                dateInit: actionTransfer.searchParam,
            }

            enableSpinner(true);
            const documents = await apiClient.getInvoicesPorte(data);
            enableSpinner(false);

            if (documents.status !== 1) {
                showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
                return;
            }

            if (documents.data.length === 0) {
                showAlert({ type: 'info', message: 'No hay información por mostrar' });
                return;
            }
            const filteredData = await this.CheckIfWasEntrySelected(documents.data, arrayEntriesChoose);

            this.setState({
                modalView: 'outStockTransfersDocs',
                outStockTransfersDocs: filteredData,
            });

            if (filteredData.length > 0) {
                $('#partnerList').modal('show');
            } else {
                showAlert({ type: 'info', message: 'No hay información por mostrar' });
            }
        }

    };

    CheckIfWasEntrySelected = (dataToFilter, toCompareData) => {
        let ArrayToFilter = dataToFilter && Array.isArray(dataToFilter) ? dataToFilter : [];
        let filteredArray = [];
        if (toCompareData.length > 0) {
            filteredArray = ArrayToFilter.filter((element) => !toCompareData.includes(element.DocEntry));
        } else {
            filteredArray = ArrayToFilter;
        }
        return filteredArray;

    }
    //#endregion

    //#region Figura Transporte
    openFiguraTrans = (open) => {
        const { showAlert, openFiguraTrans, model } = this.props;
        if (model.FiguraTransporte !== '') {
            openFiguraTrans(open);
        } else {
            showAlert({ type: 'info', message: 'Debe seleccionar una de Figura Transporte' });
        }
    }
    //#endregion

    //#region Transporte
    openTransporte = (open) => {
        const { showAlert, openTransporte, model } = this.props;
        if (model.Transporte !== '') {
            openTransporte(open);
        } else {
            showAlert({ type: 'info', message: 'Debe seleccionar un Transporte' });
        }
    }
    //#endregion

    //#region Mercancia Modal
    openItemDetail = (itemModel) => {
        this.setState({ itemModel });
        $('#MercanciaPorteModal').modal('show');
    }

    deleteItem = async (index, docEntry) => {
        const { model, showAlert, } = this.props;
        const { arrayEntriesChoose } = this.state
        // let countMerc = 0;
        // let NumAtCard = '';
        // for (let index = 0; index < model.Mercancias.length; index++) {
        //     const mercacia = model.Mercancias[index];
        //     if (mercacia.DocEntry === docEntry) {
        //         NumAtCard = mercacia.NumAtCard || 'Sin Folio';
        //         countMerc++;
        //     }
        // }
        // if (countMerc > 0) {
        //     showAlert({ type: 'warning', message: 'Se eliminaron ' + countMerc + ' lineas de la factura ' + NumAtCard });
        // }
        // let auxLinesMercancias = model.Mercancias.filter((objeto) => objeto.DocEntry !== docEntry);
        // let auxLinesUbicaciones = model.Ubicaciones.filter((objeto) => objeto.DocEntry !== docEntry);
        // model.Mercancias = auxLinesMercancias;
        // model.Ubicaciones = auxLinesUbicaciones;
        const cacheDocEntryToDelete = model.Mercancias[index].DocEntry;
        let auxArrayMercancias = model.Mercancias;
        auxArrayMercancias.splice(index, 1); // 1 es la cantidad de elemento a eliminar
        model.Mercancias = auxArrayMercancias;
        model.NumTotalMercancias = model.Mercancias.length ?? 0;
        const LineRecentlyDeleted = model.Mercancias.find((mercancia) => mercancia.DocEntry === cacheDocEntryToDelete);
        if (LineRecentlyDeleted === undefined) { // that means the user was delete all lines related with a doc
            const auxArray = await this.DeleteChooseEntry(arrayEntriesChoose, cacheDocEntryToDelete);
            showAlert({ type: 'info', message: 'Eliminaste todas lineas relacionadas con el documento: ' + cacheDocEntryToDelete });
            const auxLinesUbicaciones = model.Ubicaciones.filter((objeto) => objeto.DocEntry !== cacheDocEntryToDelete);
            model.Ubicaciones = auxLinesUbicaciones;
            await this.setState({
                arrayEntriesChoose: auxArray
            })
        }
        this.refreshModel(model);
    }

    DeleteChooseEntry = (arr, docEntry) => {
        let modifiedArray = arr;
        const index = modifiedArray.findIndex((element) => Number(element) === Number(docEntry));

        if (index !== -1) {
            modifiedArray.splice(index, 1);
        }
        return modifiedArray;
    };

    ChangeQuantityMercancia = async (value, index) => {
        const { model, showAlert } = this.props;
        if (isNaN(value)) {
            showAlert({ type: 'warning', message: `Ingresa un valor valido (Números)` });
            return
        }
        if (Number(value) <= 0) {
            showAlert({ type: 'warning', message: `Ingresa un valor valido (Valores mayores a 0 por favor)` });
            return
        }
        const newMercancias = model.Mercancias.map((mercancia, indexMerch) => {
            if (index === indexMerch) {
                mercancia.Cantidad = value;
            }
            return mercancia;
        })
        model.Mercancias = newMercancias
        this.refreshModel(model);
        await setTimeout(() => {
            this.ValidateQuantityMercancia();
        }, 2000)
    };

    ValidateQuantityMercancia = () => {
        const { model, showAlert } = this.props;
        const { usoInterno } = this.state;
        if (usoInterno) { return; }
        model.Mercancias.forEach((mercancia, index) => {
            if (Number(mercancia.Cantidad) > Number(mercancia.HomeQuantity)) {
                showAlert({ type: 'warning', message: `Ingresaste una cantidad a entregar mayor de la que puedes en la linea de mercancia ${index + 1}. ClaveProdServ:  ${mercancia.claveProdServ}`, timeOut: 4000 });
                showAlert({ type: 'info', message: `La cantidad de ese articulo regresara a su valor máximo permitido`, timeOut: 4000 });
                this.ChangeQuantityMercancia(mercancia.HomeQuantity, index);
            }
        });
    }
    //#endregion

    //#region address Modal
    openAddressDetail = (addressModel) => {
        this.setState({
            addressModel,
            flagAddressesPorteModal: true,
            municipios: [],
            localidades: [],
            colonias: [],
        });
        if (addressModel.CodigoPostal && addressModel.CodigoPostal !== '') { this.getCodigoPostalSAT(addressModel, addressModel.CodigoPostal); }
        else { this.fillAddressInfo(addressModel) }
        setTimeout(() => {
            $('#AddressesPorteModal').modal('show');
        }, 1200);
    }

    openAddresses = async () => {
        const { enableSpinner, showAlert, model } = this.props;
        if (!model.CardCode) {
            showAlert({ type: 'info', message: 'Primero seleccione a un socio de negocio' });
            return;
        }
        enableSpinner(true);
        const businesPartnerResponse = await apiClient.getPartnerDetails(model.CardCode);
        if (businesPartnerResponse.status === SERVICE_RESPONSE.SUCCESS) {
            if (businesPartnerResponse?.data?.deliveriesAddress.length > 0) {
                this.setState({ addresses: businesPartnerResponse?.data?.deliveriesAddress ?? [] });
                setTimeout(() => {
                    $('#addressPartnerModal').modal('show');
                }, 100)
                enableSpinner(false);
                return;
            }
        }
        enableSpinner(false);
        showAlert({ type: 'info', message: 'No hay ubicaciones para mostrar' });
        return;
    };

    selectAddresses = async (address) => {
        const { addressModel, addresses } = this.state;
        const { model } = this.props;
        let selectedAddress = addresses[address.index];
        addressModel['Calle'] = selectedAddress?.Street ?? '';
        addressModel['NumeroExterior'] = selectedAddress?.StreetNo ?? '';
        addressModel['CodigoPostal'] = selectedAddress?.ZipCode ?? '';
        addressModel['Estado'] = selectedAddress?.state ?? '';
        addressModel['Municipio'] = selectedAddress?.City ?? '';
        addressModel['Localidad'] = selectedAddress?.City ?? '';
        addressModel['Colonia'] = selectedAddress?.Block ?? '';
        model.Ubicaciones[addressModel.Index] = addressModel;
        this.refreshModel(model);
        await this.getCodigoPostalSAT(addressModel, selectedAddress?.ZipCode ?? '');
        $('#addressPartnerModal').modal('hide');
    };

    searchStatesCatalog = async () => {
        const states = await apiClient.getStateSAT('MEX');
        if (states.status === SERVICE_RESPONSE.SUCCESS) { this.setState({ states: states.data ?? [] }); }
    }

    getAddressDetailSAT = async (type, value, addressModel, byTab = false) => {
        const { enableSpinner } = this.props;
        const { colonias } = this.state;
        let newData;
        let newData2;
        if (type === 'Pais') {
            addressModel.Estado = '';
            addressModel.Municipio = '';
            addressModel.Localidad = '';
            addressModel.Colonia = '';
            addressModel.CodigoPostal = '';
            this.setState({ municipios: [], localidades: [], colonias: [] });
        }
        if (type === 'CodigoPostal') {
            addressModel.Pais = '';
            addressModel.Estado = '';
            addressModel.Municipio = '';
            addressModel.Localidad = '';
            addressModel.Colonia = '';
            this.setState({ municipios: [], localidades: [], colonias: [] });
        }
        if (addressModel.Pais === 'MEX') {
            if (type === 'Estado') {
                addressModel.Municipio = '';
                addressModel.Localidad = '';
                addressModel.Colonia = '';
                // addressModel.CodigoPostal = ''; // No reiniciar código postal
                this.setState({ municipios: [], localidades: [], colonias: [] });
                enableSpinner(true);
                newData = await apiClient.getMunicipioSAT(value);
                newData2 = await apiClient.getLocalidadSAT(value);
                if (newData.status === SERVICE_RESPONSE.SUCCESS) { this.setState({ municipios: newData.data ?? [] }); }
                if (newData2.status === SERVICE_RESPONSE.SUCCESS) { this.setState({ localidades: newData2.data ?? [] }); }
                enableSpinner(false);
            } else if (type === 'Municipio') {
                if (!byTab) { addressModel.Colonia = ''; }
                // addressModel.CodigoPostal = ''; // No reiniciar código postal
                this.setState({ colonias: [] });
                enableSpinner(true);
                newData = await apiClient.getAddressDetailSAT({ action: 'getTowns', state: addressModel.Estado, municipality: addressModel.Municipio, district: addressModel.Localidad });
                if (newData.status === SERVICE_RESPONSE.SUCCESS) {
                    this.setState({ colonias: await this.FilterArrayDoubleValues('Colonias', newData.data) ?? [] });
                }
                enableSpinner(false);
            } else if (type === 'Localidad' && addressModel.Municipio) {
                addressModel.Colonia = '';
                // addressModel.CodigoPostal = ''; // No reiniciar código postal
                this.setState({ colonias: [] });
                enableSpinner(true);
                newData = await apiClient.getAddressDetailSAT({ action: 'getTowns', state: addressModel.Estado, municipality: addressModel.Municipio, district: addressModel.Localidad });
                if (newData.status === SERVICE_RESPONSE.SUCCESS) { this.setState({ colonias: newData.data ?? [] }); }
                enableSpinner(false);
            } else if (type === 'Colonia') {
                addressModel.Colonia = value;
                const cp = colonias.find(col => col.c_Colonia === addressModel.Colonia);
                addressModel.CodigoPostal = cp?.c_CodigoPostal ?? '';
                // addressModel.Localidad = cp?.c_Localidad ?? ''; // lo comete porque no querian que se reinciara el de localidad
            }
        }
        await this.refreshModelUbications(addressModel);
    }

    FilterArrayDoubleValues = (propertyCompare, array) => {
        const uniqueIds = {};
        const resultado = [];
        array.forEach(obj => {
            if (!uniqueIds[obj[propertyCompare]]) {
                uniqueIds[obj[propertyCompare]] = true;
                resultado.push(obj);
            }
        });
        return resultado;
    }

    fillAddressInfo = async (addressModel) => {
        const { enableSpinner } = this.props;
        let newData;
        let newData2;
        if (addressModel.Pais === 'MEX') {
            if (addressModel.Estado && addressModel.Estado !== '') {
                enableSpinner(true);
                newData = await apiClient.getMunicipioSAT(addressModel.Estado);
                newData2 = await apiClient.getLocalidadSAT(addressModel.Estado);
                if (newData.status === SERVICE_RESPONSE.SUCCESS) { this.setState({ municipios: newData.data ?? [] }); }
                if (newData2.status === SERVICE_RESPONSE.SUCCESS) { this.setState({ localidades: newData2.data ?? [] }); }
                enableSpinner(false);

                if (addressModel.Municipio && addressModel.Municipio !== '') {
                    enableSpinner(true);
                    newData = await apiClient.getAddressDetailSAT({ action: 'getTowns', state: addressModel.Estado, municipality: addressModel.Municipio, district: addressModel.Localidad });
                    if (newData.status === SERVICE_RESPONSE.SUCCESS) {
                        this.setState({ colonias: await this.FilterArrayDoubleValues('Colonias', newData.data) ?? [] });
                    }
                    enableSpinner(false);

                    if (addressModel.Localidad && addressModel.Localidad !== '') {
                        enableSpinner(true);
                        newData = await apiClient.getAddressDetailSAT({ action: 'getTowns', state: addressModel.Estado, municipality: addressModel.Municipio, district: addressModel.Localidad });
                        if (newData.status === SERVICE_RESPONSE.SUCCESS) { this.setState({ colonias: newData.data ?? [] }); }
                        enableSpinner(false);
                    }
                }
            }
        }
    }

    getCodigoPostalSAT = async (addressModel, codigoPostal) => {
        const { showAlert, enableSpinner } = this.props;
        this.setState({
            municipios: [],
            localidades: [],
            colonias: [],
        });
        if (!codigoPostal) {
            addressModel.Pais = '';
            addressModel.Estado = '';
            addressModel.Municipio = '';
            addressModel.Localidad = '';
            addressModel.Colonia = '';
            showAlert({ type: 'info', message: 'No hay un Codigo postal' });
            return;
        }

        enableSpinner(true); // Busca de dos formas los datos para el CP seleccionado
        let codigoPostalSATResponse = await apiClient.getAddressDetailSAT({ action: 'getAddressesByZipCode', zipCode: codigoPostal });
        if (codigoPostalSATResponse.data.length === 0) { codigoPostalSATResponse = await apiClient.getAddressDetailSAT({ action: 'getAddressesByZipCode2', zipCode: codigoPostal }); }
        enableSpinner(false);
        // Si no hay resultados para las dos búsquedas no continua con el resto
        if (codigoPostalSATResponse.data.length === 0) { showAlert({ type: 'info', message: `No hay información por mostrar, con ese codigo postal: ${codigoPostal ?? ''}` }); return; }
        if (codigoPostalSATResponse.status === SERVICE_RESPONSE.SUCCESS) {
            enableSpinner(true);
            codigoPostalSATResponse.data = await this.FilterArrayDoubleValues('Colonias', codigoPostalSATResponse.data)
            addressModel.Pais = codigoPostalSATResponse.data[0] ? codigoPostalSATResponse.data[0].c_Pais : '';
            const municipalityData = await apiClient.getMunicipioSAT(codigoPostalSATResponse.data[0].c_Estado ?? '');
            const districtData = await apiClient.getLocalidadSAT(codigoPostalSATResponse.data[0].c_Estado ?? '');
            await this.setState({
                municipios: municipalityData.data ?? [],
                localidades: districtData.data ?? [],
                colonias: codigoPostalSATResponse.data ?? [],
            });

            if (addressModel.Estado) {
                let states = codigoPostalSATResponse.data.find(state => state.Estado.toLowerCase().includes(addressModel.Estado.toLowerCase()) || state.c_Estado === addressModel.Estado);
                if (states) {
                    if (states.length > 1) { addressModel.Estado = states[0].c_Estado; }
                    else { addressModel.Estado = states.c_Estado; }
                } else {
                    addressModel.Estado = codigoPostalSATResponse.data[0] ? codigoPostalSATResponse.data[0].c_Estado : '';
                    showAlert({ type: 'info', message: 'No hay estados correspondientes al seleccionado' });
                }
            } else { addressModel.Estado = codigoPostalSATResponse.data[0] ? codigoPostalSATResponse.data[0].c_Estado : ''; }

            if (addressModel.Municipio) {
                let municipios = codigoPostalSATResponse.data.find(mun => mun.Municipio.toLowerCase().includes(addressModel.Municipio.toLowerCase()) || mun.c_Municipio === addressModel.Municipio);
                if (municipios) {
                    if (municipios.length > 1) { addressModel.Municipio = municipios[0].c_Municipio; }
                    else { addressModel.Municipio = municipios.c_Municipio; }
                } else {
                    addressModel.Municipio = codigoPostalSATResponse.data[0] ? codigoPostalSATResponse.data[0].c_Municipio : '';
                    showAlert({ type: 'info', message: 'No hay municipios correspondientes al seleccionado' });
                }
            } else { addressModel.Municipio = codigoPostalSATResponse.data[0] ? codigoPostalSATResponse.data[0].c_Municipio : ''; }

            if (addressModel.Localidad) {
                let localidad = codigoPostalSATResponse.data.find(loc => loc.Localidad.toLowerCase().includes(addressModel.Localidad.toLowerCase()) || loc.c_Localidad === addressModel.Localidad);
                if (localidad) {
                    if (localidad.length > 1) { addressModel.Localidad = localidad[0].c_Localidad; }
                    else { addressModel.Localidad = localidad.c_Localidad; }
                } else {
                    addressModel.Localidad = codigoPostalSATResponse.data[0] ? codigoPostalSATResponse.data[0].c_Localidad : '';
                    showAlert({ type: 'info', message: 'No hay localidades correspondientes a la seleccionada' });
                }
            } else { addressModel.Localidad = codigoPostalSATResponse.data[0] ? codigoPostalSATResponse.data[0].c_Localidad : ''; }

            if (addressModel.Colonia) {
                let colonia = codigoPostalSATResponse.data.find(col => col.Colonias.toLowerCase().includes(addressModel.Colonia.toLowerCase()) || col.c_Colonia === addressModel.Colonia);
                if (colonia) {
                    if (colonia.length > 1) { addressModel.Colonia = colonia[0].c_Colonia; }
                    else { addressModel.Colonia = colonia.c_Colonia; }
                } else {
                    showAlert({ type: 'info', message: 'No hay colonias correspondientes a la seleccionada' });
                }
            }
            await this.refreshModelUbications(addressModel);
            enableSpinner(false);
            return;
        }
        enableSpinner(false);
        showAlert({ type: 'info', message: 'No hay Información por mostrar' });
    }

    refreshModelUbications = (addressModel) => {
        const { model } = this.props;
        model.Ubicaciones[addressModel.Index] = addressModel;
        this.refreshModel(model);
    };

    addAddressElement = () => {
        const { model } = this.props;
        let newAddress = new UbicacionPorte();
        if (model.TypeDoc !== 'I') {
            newAddress = {
                ...newAddress,
                RFCRemitenteDestinatario: Datos_Empresa.RFC,
                NombreRemitenteDestinatario: Datos_Empresa.Nombre,
                DistanciaRecorrida: 0,
                Calle: `${Datos_Empresa.Calle}, COL. ${Datos_Empresa.Colonia}`,
                NumeroExterior: '660',
                Estado: 'SIN',
                Localidad: '02',
                Pais: 'MEX',
                Municipio: '006',
                CodigoPostal: Datos_Empresa.CP,
                DocEntry: '55',
            }
        }
        model.Ubicaciones.push(newAddress)
        this.refreshModel(model);
    }

    removeAddressElement = (index) => {
        const { model } = this.props;
        model.Ubicaciones.splice(index, 1);
        this.refreshModel(model);
    }
    //#endregion

    //#region TIMBRADO
    billingInfo = action => {
        const { billing, model } = this.props;
        // billing(model.indexRowDetails, action, model.Remarks);
    };
    //#endregion

    //#region BUSCAR FACTURAS POR FECHA
    searchDocuments = async date => {
        await this.callDocumentsListService(date);
    };

    callDocumentsListService = async newDate => {
        const { showAlert, enableSpinner, model } = this.props;

        let data = {
            action: 'getInvoicesHeader',
            DocEntry: model.CardCode,
            dateInit: newDate.dateInit,
            dateFinal: newDate.dateFinal,
        };
        enableSpinner(true);
        // console.log('con<data', data);
        let invoiceListResponse = await apiClient.getInvoicesPorte(data);
        enableSpinner(false);

        if (invoiceListResponse.status === SERVICE_RESPONSE.SUCCESS) {
            // console.log('con<invoiceListResponse', invoiceListResponse.data.length);
            this.setState({
                invoices: invoiceListResponse.data,
            });
            return;
        }
    }
    //#endregion=

    //#region CONCEPTS
    AddConceptLine = () => {
        const { model, showAlert } = this.props;
        const { usoInterno } = this.state;

        if (model.TypeDoc === 'T') {
            showAlert({ type: 'info', message: 'Tu carta porte es de tipo traslado, los conceptos se generaran en automático a la hora de crearse la carta porte.', timeOut: 9000 });
            return;
        }
        if (model.TypeDoc !== 'T' && model.CardCode === '' && !usoInterno) {
            showAlert({ type: 'info', message: 'Selecciona un socio de negocios por favor.' });
            return;
        }
        model.Concepts.push(new ConceptoPorte());
        this.refreshModel(model);
    }

    ChangeQtyConcept = (value, index) => {
        const { showAlert, model } = this.props
        if (isNaN(value)) {
            showAlert({ type: 'warning', message: 'Ingrese un valor valido por favor.' });
            return;
        }
        let auxConcepts = model.Concepts;
        auxConcepts[index].Cantidad = Number(value).toFixed(6);
        model.Concepts = auxConcepts;
        this.refreshModel(model);
        this.SumEachFleteConcept();
    }

    ChangeUnityConcept = (value) => {
        const { model } = this.props
        const auxArray = value.split(',');
        let auxConcepts = model.Concepts;
        auxConcepts[auxArray[2]].ShowUnidad = value;
        auxConcepts[auxArray[2]].Unidad = auxArray[1];
        auxConcepts[auxArray[2]].ClaveUnidad = auxArray[0];
        model.Concepts = auxConcepts;
        this.refreshModel(model);
    }

    ChangeCodProdSAT = (value, indexLine) => {
        const { model, showAlert } = this.props
        if (isNaN(value)) {
            showAlert({ type: 'warning', message: 'Solo claves numéricas por favor.' });
            return;
        }
        let auxConcepts = model.Concepts;
        auxConcepts[indexLine].ClaveProdServ = value;
        model.Concepts = auxConcepts;
        this.refreshModel(model);
        this.SumEachFleteConcept();

    }

    SumEachFleteConcept = () => {
        const { model } = this.props
        let totalFlete = 0;
        totalFlete = model.Concepts.reduce((total, Concept) => {
            let finalTotal = 0;
            if (Number(Concept.ClaveProdServ) === 78101802) {
                finalTotal = Number(Concept.ValorUnitario) * Number(Concept.Cantidad);
                finalTotal = (finalTotal - (finalTotal * (Concept.Descuento / 100)))
            }
            return total + finalTotal;
        }, 0);
        model.TotalFlete = totalFlete;
        this.refreshModel(model);
    }

    ChangeConceptDescription = async (value, indexLine) => {
        const { model } = this.props
        model.Concepts[indexLine].Descripcion = value;
        await this.refreshModel(model);
    }

    ChangeNoIdentification = async (value, indexLine) => {
        const { model } = this.props
        model.Concepts[indexLine].NoIdentificacion = value;
        await this.refreshModel(model);
    }

    ChangeConceptImporte = async (value, indexLine) => {
        const { model } = this.props
        model.Concepts[indexLine].Importe = value;
        await this.refreshModel(model);
    }

    ChangeConceptValorUnitario = async (value, indexLine) => {
        const { model, showAlert } = this.props
        if (isNaN(value)) {
            showAlert({ type: 'warning', message: 'Ingrese un valor valido por favor.' });
            return;
        }
        model.Concepts[indexLine].ValorUnitario = value;
        await this.refreshModel(model);
        this.SumEachFleteConcept();
    }

    ChangeDescuento = async (value, indexLine) => {
        const { model, showAlert } = this.props
        if (isNaN(value)) {
            showAlert({ type: 'warning', message: 'Ingrese un valor valido por favor.' });
            return;
        }
        model.Concepts[indexLine].Descuento = value;
        await this.refreshModel(model);
        this.SumEachFleteConcept();
    }

    ChangeObjImpuesto = async (value, indexLine) => {
        const { model } = this.props
        model.Concepts[indexLine].ObjetoImp = value;
        await this.refreshModel(model);
    }

    OpenClaveProdSAT = async (indexLine, typeCve = 0, SAPSearch = false) => {
        await this.setState({
            SearchModalModel: { Clave: '', Description: '' },
            ClaveProdByKey: [],
            auxiliarIndexLine: indexLine,
            typeCve,
            SAPSearch,
        })
        $('#claveProdSATModal').modal('show');
    }

    CloseClaveProdModal = () => {
        $('#claveProdSATModal').modal('hide');
    }

    RefreshSearchModalModel = async (model) => {
        await this.setState({
            SearchModalModel: model
        })
    }

    SearchBySearchModel = async () => {
        const { typeCve, SAPSearch } = this.state;
        const { enableSpinner, showAlert } = this.props;

        if (this.state.SearchModalModel.Clave && this.state.SearchModalModel.Description) {
            showAlert({ type: 'info', message: 'Por favor ingresa, un valor para buscar las claves' });
            return;
        }

        const data = {
            SearchModalModel: this.state.SearchModalModel,
            typeCve,
            SAPSearch
        }

        enableSpinner(true);
        const responseApi = await apiClient.getClaveProd(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: responseApi?.message ?? '' });
            return;
        }

        if (responseApi.data && responseApi.data.length === 0) {
            showAlert({ type: 'error', message: 'No se encontró información con esos parámetros de búsqueda' });
            return;
        }

        await this.setState({
            ClaveProdByKey: responseApi?.data ?? []
        });
    }

    SelectClaveProd = async (indexArray) => {
        const { ClaveProdByKey, auxiliarIndexLine, typeCve, itemModel } = this.state;
        const { model } = this.props;
        let selectedOption;

        switch (typeCve) {
            case 0:
                selectedOption = ClaveProdByKey[indexArray.index];
                itemModel.BienesTransp = selectedOption.c_ClaveProdServ ? selectedOption.c_ClaveProdServ : '';
                itemModel.Descripcion = selectedOption.Descripcion ? selectedOption.Descripcion : '';
                itemModel.ClaveUnidad = selectedOption.CveUM ? selectedOption.CveUM : '';
                itemModel.ValorMercancia = selectedOption.Price ? selectedOption.Price : '';
                itemModel.Moneda = selectedOption.Currency ? selectedOption.Currency : '';
                itemModel.PesoEnKg = selectedOption.Weight ? selectedOption.Weight : '';
                model.Mercancias[itemModel.Index] = itemModel;
                await this.refreshModel(model);
                break;
            case 1:
                selectedOption = ClaveProdByKey[indexArray.index];
                itemModel.ClaveUnidad = selectedOption.c_ClaveProdServ ? selectedOption.c_ClaveProdServ : '';
                model.Mercancias[itemModel.Index] = itemModel;
                await this.refreshModel(model);
                break;
            default:
                selectedOption = ClaveProdByKey[auxiliarIndexLine];
                await this.ChangeCodProdSAT(selectedOption.c_ClaveProdServ, auxiliarIndexLine);
                break;
        }

        await this.setState({
            typeCve: 0,
            auxiliarIndexLine: '',
        });
        $('#claveProdSATModal').modal('hide');
    }

    RemoveConcept = (indexLine) => {
        const { model } = this.props;
        model.Concepts.splice(indexLine, 1);
        this.refreshModel(model);
        this.SumEachFleteConcept()
    }

    DownloadDocCartaPorte = async (type) => {
        const { model, showAlert, enableSpinner } = this.props;
        const { usoInterno } = this.state;
        if (usoInterno) {
            model.SerieCode = 'UI';
            model.SerieName = 'UsoInterno';
        }
        const data = {
            docNum: '555_' + model.DocNum,
            serie: 'CARTA_PORTE_' + model.CodigoCarta + "_" + (model.CardCode !== "" && model.CardCode !== null && model.CardCode !== undefined ? model.CardCode : 'SCC') + '_' + model.SerieCode,
            serieName: model.SerieName,
            type
        }
        enableSpinner(true);
        const responsePdf = await apiClient.DownloadDocuments(data);
        enableSpinner(false);
        let getFieldName = responsePdf.headers.get('content-disposition');
        if (getFieldName !== null) {
            // Get File Name from HTTP header
            let start = getFieldName.indexOf("filename=") + 10;
            let end = getFieldName.indexOf('"', start);
            try {
                responsePdf.blob().then(blob => download(blob, getFieldName.slice(start, end)));
            } catch (e) {
                showAlert({ type: 'error', message: `Error al traer el ${type} de CARTA PORTE`, timeOut: 5000 });
            }
        }
        else {
            showAlert({ type: 'error', message: 'No se encontró el archivo en su ruta', timeOut: 5000 });
        }
    }

    DownloadCancelationCartaPorte = async (type) => {
        const { model, showAlert, enableSpinner } = this.props;

        if (!model.xml_Process && model.xml_Process !== '') {
            showAlert({ type: 'error', message: `Falta información de timbrado para solicitar la solicitud de cancelación `, timeOut: 5000 });
        }
        const Timbra_Object = JSON.parse(model.xml_Process);

        const data = {
            nameDocument: 'CARTA_PORTE_CC_' + model.CodigoCarta + "_" + Timbra_Object.cfdiReceptor._attributes.Rfc + '_' + model.U_FMB_UUID,
            type,
        }
        enableSpinner(true);
        const responsePdf = await apiClient.DownloadCancelationDocuments(data);
        enableSpinner(false);

        const getFieldName = responsePdf.headers.get('content-disposition');
        if (getFieldName !== null) {
            // Get File Name from HTTP header
            let start = getFieldName.indexOf("filename=") + 10;
            let end = getFieldName.indexOf('"', start);
            try {
                responsePdf.blob().then(blob => download(blob, getFieldName.slice(start, end)));
            } catch (e) {
                showAlert({ type: 'error', message: `Error al traer el ${type} de cancelación de la CARTA PORTE`, timeOut: 5000 });
            }
        }
        else {
            showAlert({ type: 'error', message: 'No se encontró el archivo en su ruta', timeOut: 5000 });
        }
    }


    //#endregion

    //#region CANCEL-CFDI
    ConsultarEstatusCFDI = async () => {
        const { model, enableSpinner, showAlert } = this.props;
        const auxObject = {
            name: "OCPT",
            complement: '',
            docSubType: "--",
            docType: "",
        }
        const data = {
            DocEntry: model.CodigoCarta,
            Table: auxObject,
        }

        enableSpinner(true);
        const response = await apiClient.ConsultarEstatusCFDI(data);
        enableSpinner(false);

        if (response.status === 0) {
            return showAlert({ type: "error", message: `${response.message ?? ''}`, timeOut: 8000 });
        } else if (response.status === 2) {
            this.setState(
                {
                    isCancelCFDI: true,
                }
            )
            return showAlert({ type: "info", message: `${response.message ?? ''}. `, timeOut: 8000 });
        } else {
            return showAlert({ type: "success", message: `${response.message ?? ''}`, timeOut: 8000 });
        }
    };

    OpenCFDI_SAT = async () => {
        window.open("https://verificacfdi.facturaelectronica.sat.gob.mx/", "_blank");
    }

    OpenModalCancelCFDI = () => {
        $('#cancelCFDI').modal('show');
    }

    CancelCFDI = async () => {
        const { model, enableSpinner, showAlert, openDetails, searchDocuments } = this.props;

        const auxObject = {
            name: "OCPT",
            complement: '',
            docSubType: "--",
            docType: "",
        }

        $('#cancelDocuments').modal('hide');

        const motivo = document.getElementById("selectCancelCFDI").value;
        const U_FMB_UUID_RELACIONADO = document.getElementById("U_FMB_UUID_RELACIONADO") !== null && document.getElementById("U_FMB_UUID_RELACIONADO") !== undefined ? document.getElementById("U_FMB_UUID_RELACIONADO").value : '';

        if (motivo === '00') {
            return showAlert({ type: "warning", message: `Parámetro inválido. El motivo de cancelación no es un valor válido`, timeOut: 8000 });
        } else if (motivo === '01' && U_FMB_UUID_RELACIONADO === '') {
            return showAlert({ type: "warning", message: `Parámetro inválido. Debes de colocar un UUID`, timeOut: 8000 });
        }

        const data = {
            DocEntry: model.CodigoCarta,
            Table: auxObject,
            Motivo: motivo || '02',
            U_FMB_UUID_RELACIONADO: U_FMB_UUID_RELACIONADO || '',
        }

        enableSpinner(true);
        let response = await apiClient.CancelCFDI(data);
        enableSpinner(false);

        $('#cancelCFDI').modal('hide');
        if (response.status === 0) {
            return showAlert({ type: "error", message: `${response.message ?? ''}`, timeOut: 8000 });
        } else if (response.status === 2) {
            return showAlert({ type: "info", message: `${response.message ?? ''}`, timeOut: 8000 });
        } else {
            enableSpinner(true);
            await searchDocuments();
            await openDetails({ Code: model.CodigoCarta });
            enableSpinner(false);
            this.setState({ isCancelCFDI: false });
            $('#DocumentCreateModal').modal('hide');
            return showAlert({ type: "success", message: `${response.message ?? ''}`, timeOut: 8000 });
        }
    };

    //#endregion

    //#region SELECT-FUNCTIONS
    searchTransporte = async () => {
        const { enableSpinner, showAlert } = this.props;

        enableSpinner(true);
        const getTransporteResponse = await apiClient.getTransporteList();
        enableSpinner(false);

        if (getTransporteResponse.status === 1) {
            this.setState({
                modalView: 'TransporteListModal',
                transportes: getTransporteResponse.data.manager,
                selectAction: this.selectTransporte,
            });
            $('#partnerList').modal('show');
        } else {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }
    }

    selectTransporte = async (transporte) => {
        const { model, enableSpinner, showAlert } = this.props;
        try {
            $('#partnerList').modal('hide');
            enableSpinner(true);
            await this.setState({
                modalView: '',
                transportes: [],
                selectAction: () => { },
            });

            model.Transporte = transporte.Codigo;
            model.TipoTransporte = transporte.TipoTransporte;
            model.ConfRemolques = JSON.parse(transporte.Remolques || '[]') ?? [];
            for (var i = 0; i < model.ConfRemolques.length; i++) { model.ConfRemolques[i].Active = i < 2; }
            await this.refreshModel(model);
            showAlert({ type: 'success', message: 'Transporte cargado correctamente', timeOut: 1000 });
            enableSpinner(false);
        } catch (e) {
            enableSpinner(false);
            $('#partnerList').modal('hide');
            showAlert({ type: 'error', message: 'Ocurrió un error al cargar la información del transporte', timeOut: 3000 });
        }
    }


    searchFiguraTransporte = async () => {
        const { enableSpinner, showAlert } = this.props;

        enableSpinner(true);
        const getFiguraTransporteResponse = await apiClient.getFiguraTransporteList();
        enableSpinner(false);

        if (getFiguraTransporteResponse.status === 1) {
            this.setState({
                modalView: 'FiguraTransporteListModal',
                figurasTransporte: getFiguraTransporteResponse.data.manager,
                selectAction: this.selectFiguraTransporte,
            });
            $('#partnerList').modal('show');
        } else {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }
    }

    selectFiguraTransporte = async (figuraTransporte) => {
        const { model, enableSpinner, showAlert } = this.props;
        try {
            $('#partnerList').modal('hide');
            enableSpinner(true);
            await this.setState({
                modalView: '',
                figurasTransporte: [],
                selectAction: () => { },
            });

            model.FiguraTransporte = figuraTransporte.CodigoFiguraTransporte;
            await this.refreshModel(model);
            showAlert({ type: 'success', message: 'Figura de transporte cargada correctamente', timeOut: 1000 });
            enableSpinner(false);
        } catch (e) {
            enableSpinner(false);
            $('#partnerList').modal('hide');
            showAlert({ type: 'error', message: 'Ocurrió un error al cargar la información de la figura de transporte', timeOut: 3000 });
        }
    }
    //#endregion

    //#region CARTA PORTE MANUAL
    validateToCleanChanges = () => {
        const { model, cleanCartaPorteModel } = this.props;
        if (model.CardCode && model.CardCode !== '') {
            this.setState({
                warningModel: {
                    message: 'Al cambiar el modo a "Llenado manual" se perderán los cambios realizados, ¿Deseas continuar?',
                    acceptMessage: 'Descartar cambios',
                    acceptAction: async () => cleanCartaPorteModel(),
                }
            });
            this.openCloseWarningModal(true);
            return;
        }
        this.validateChangeFillMode();
    }

    validateChangeFillMode = () => {
        const usoInterno = !this.state.usoInterno;
        const { model } = this.props;
        const event = { nativeEvent: { target: { value: usoInterno ? 'Y' : '' } } };
        this.changeFieldModel(model, 'UsoInterno', event);
        this.setState({ usoInterno });
    }

    openNewItem = () => {
        const { model } = this.props;
        let itemModel = new Mercancia();
        itemModel.Index = model.Mercancias?.length || 0;
        model.Mercancias.push(itemModel);
        this.refreshModel(model);

        this.setState({ itemModel });
        $('#MercanciaPorteModal').modal('show');
    }

    cleanMercanciaModel = () => {
        this.setState({ itemModel: {} });
        $('#MercanciaPorteModal').modal('hide');
    }

    selectSAPClient = async (partnerData) => {
        const { enableSpinner, showAlert, model, refreshModel } = this.props;
        try {
            enableSpinner(true);
            const partnerResponse = await apiClient.getBPUsoInterno(partnerData);
            if (partnerResponse.status === 0) {
                enableSpinner(false);
                $('#partnerList').modal('hide');
                showAlert({ type: 'error', message: 'Ocurrió un error al buscar la información del socio de negocio', timeOut: 3000 });
                return;
            }
            model.CardCode = partnerResponse.data.CardCode;
            model.CardName = partnerResponse.data.CardName;
            model.LicTradNum = partnerResponse.data.LicTradNum;
            model.ZipCode = partnerResponse.data.ZipCode;
            model.U_FMB_REGIMEN_FISCAL = partnerResponse.data.U_FMB_REGIMEN_FISCAL;
            model.UsoCFDI = partnerResponse.data.U_FMB_USO_CFDI;
            await refreshModel(model);
            $('#partnerList').modal('hide');
            showAlert({ type: 'success', message: 'Datos del socio de negocio cargados correctamente', timeOut: 3000 });
            enableSpinner(false);
        } catch (error) {
            enableSpinner(false);
            $('#partnerList').modal('hide');
            showAlert({ type: 'error', message: 'Ocurrió un error al cargar la información del socio de negocio', timeOut: 3000 });
        }
    }

    //#endregion

    //#region RENDER
    renderEditButton = () => {
        const { action } = this.props;
        const { editMode } = this.state;
        if (action === 2 && !editMode) {
            return (
                <button
                    type="button"
                    style={{ backgroundColor: 'transparent', color: '#000' }}
                    className="btn btn-editar"
                    onClick={this.validateEditMode}>
                    <i className="fas fa-edit  fa-lg" />
                    Editar
                </button>
            );
        }
    };

    renderFieldsButton = () => {
        const { openConfigFieldsModal } = this.props;
        return (
            <button
                type="button"
                style={{ backgroundColor: 'transparent', color: '#000', textAlign: 'right' }}
                className="btn"
                onClick={openConfigFieldsModal}>
                <i className="fas fa-cog" />
                &nbsp;Mostrar Campos
            </button>
        );
    };

    renderPorteHeader = () => {
        const { model, action, countries, regimenFiscal } = this.props;
        const { editMode, usoInterno } = this.state;

        if (usoInterno) {
            return (
                <>
                    {/* Datos generales de la carta porte */}
                    <h4>Datos generales</h4>
                    <div className="row">
                        {/*PRIMER COLUMNA CARTA PORTE*/}
                        <div className="col-12 col-md-6">
                            {/*Código CARTA PORTE*/}
                            {(action !== 1) &&
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend ">
                                        <span className="input-group-text font-weight-bold" id="txtPartner">Código</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        id="txtCardCode"
                                        disabled={true}
                                        value={model.CodigoCarta ? model.CodigoCarta : ""}
                                    />
                                </div>
                            }

                            {/*Version CARTA PORTE*/}
                            <div className="input-group mb-3">
                                <div className="input-group-prepend ">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Version</span>
                                </div>
                                <select
                                    id="cartaPorteVersion"
                                    className="form-control"
                                    value={model?.Version ?? ""}
                                    onChange={(event) => this.ChangeVersionCartaPorte(event.target.value)}
                                    disabled={true}
                                >
                                    <option value=''>Seleccione una opción</option>
                                    <option value='3.1'>3.1</option>
                                    <option value='3.0'>3.0</option>
                                    <option value='2.0'>2.0</option>
                                </select>
                            </div>

                            {/* IdCCP CARTA PORTE*/}
                            <div className="input-group mb-3">
                                <div className="input-group-prepend ">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">IdCCP</span>
                                </div>
                                <input type=" text" className="form-control"
                                    id="txt_IdCCP"
                                    disabled={true}
                                    value={model?.IdCCP ?? ''}
                                />
                                <button type="button"
                                    className="input-group-text" style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                    onClick={() => this.GuideUser('IdCCP')}>
                                    <i className="fa fa-info-circle" />
                                </button>
                            </div>

                            {/* TranspInternac CARTA PORTE */}
                            {/* <div className="input-group mb-3">
                                <div class="input-group-prepend ">
                                    <span class="input-group-text font-weight-bold" id="basic-addon1">Sale del país</span>
                                </div>
                                <select class="form-control" id="cartaPorteTranspInternac"
                                    disabled
                                    value={model?.TranspInternac ?? "No"}
                                    // onChange={(event) => this.ChangeTranspInternac(event.target.value)}
                                    >
                                    <option value='No'>No</option>
                                    <option value='Si'>Si</option>
                                </select>
                                <button type="button"
                                    class="input-group-text" style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                    onClick={() => this.GuideUser('TranspInternac')}>
                                    <i class="fa fa-info-circle" />
                                </button>
                            </div> */}

                            {/*PaisOrigenDestino CARTA PORTE*/}
                            {/* <div className="input-group mb-3">
                                <div class="input-group-prepend ">
                                    <span class="input-group-text font-weight-bold" id="basic-addon1">Pais de Origen/Destino</span>
                                </div>
                                <select className="form-control"
                                    id="txtTel1"
                                    disabled={(action === 2 && !editMode) || (model.TranspInternac !== 'Si')}
                                    onChange={(event) => this.changeFieldModel(model, "PaisOrigenDestino", event)}
                                    value={model.PaisOrigenDestino ? model.PaisOrigenDestino.trim() : ""}
                                    >
                                    <option value=''>Seleccione una opción</option>
                                    {countries && countries.length > 0 && countries.map((dato => {
                                        return (
                                            <option value={dato.c_Pais}>{dato.Nombre}</option>
                                        );
                                    }))}
                                </select>
                            </div> */}

                            {/*Entrada o Salida Mercancia CARTA PORTE*/}
                            {/* <div className="input-group mb-3">
                                <div class="input-group-prepend ">
                                    <span class="input-group-text font-weight-bold" id="basic-addon1">Tipo de Entrada/Salida</span>
                                </div>
                                <select className="form-control"
                                    disabled={(action === 2 && !editMode) || (model.TranspInternac !== 'Si')}
                                    value={model.PaisOrigenDestino ? model.PaisOrigenDestino.trim() : ""}
                                    onChange={(event) => this.changeFieldModel(model, "EntradaSalidaMerc", event)}
                                    >
                                    <option value=''>Seleccione una opción</option>
                                    <option value='Entrada'>ENTRADA</option>
                                    <option value='Salida'>SALIDA</option>
                                </select>
                            </div> */}

                            {/*ViaEntradaSalida CARTA PORTE*/}
                            {/* <div className="input-group mb-3">
                                <div class="input-group-prepend ">
                                    <span class="input-group-text font-weight-bold" id="basic-addon1">Via de Entrada/Salida</span>
                                </div>
                                <select id="txtGroupCode" class="form-control"
                                    value={model.ViaEntradaSalida ? model.ViaEntradaSalida.trim() : ''}
                                    onChange={(event) => this.changeFieldModel(model, "ViaEntradaSalida", event)}
                                    disabled={(action === 2 && !editMode) || (model.TranspInternac !== 'Si')}
                                    >
                                    <option value=''>Seleccione una opción</option>
                                    <option value='01'>01. Autotransporte</option>
                                    <option value='03'>03. Transporte Aéreo</option>
                                </select>
                            </div> */}
                        </div>

                        {/*SEGUNDA COLUMNA CARTA PORTE*/}
                        <div className="col-12 col-md-6">

                            {/* MONEDA */}
                            {/* <div className="input-group mb-3">
                                <div class="input-group-prepend ">
                                    <span class="input-group-text font-weight-bold" id="basic-addon1">Moneda</span>
                                </div>
                                <select className="form-control"
                                    disabled
                                    value={model?.Currency ?? "MXN"}
                                    // onChange={(event) => this.changeFieldModel(model, "Currency", event)}
                                    >
                                    <option value="MXN">MXN</option>
                                    <option value="MXP">MXP</option>
                                    <option value="USD">USD</option>
                                </select>
                            </div> */}

                            {/* TotalDistRec CARTA PORTE */}
                            <div className="input-group mb-3">
                                <div className="input-group-prepend ">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Distancia Total</span>
                                </div>
                                <input type=" text" className="form-control"
                                    id="txtCardName"
                                    disabled={true}
                                    onChange={(event) => this.changeFieldModel(model, "TotalDistRec", event)}
                                    value={model.TotalDistRec ? model.TotalDistRec : ""}
                                />
                                <button type="button"
                                    className="input-group-text" style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                    onClick={() => this.GuideUser('TotalDistRec')}>
                                    <i className="fa fa-info-circle" />
                                </button>
                            </div>

                            {/* TotalDistRec CARTA PORTE */}
                            <div className="input-group mb-3">
                                <div className="input-group-prepend ">
                                    <span className="input-group-text font-weight-bold">Total Flete</span>
                                </div>
                                <input type="number" className="form-control"
                                    id="numberTotalFlete"
                                    autoComplete="off"
                                    // disabled={action === 2 ? true : false}
                                    // onChange={(event) => this.changeFieldModel(model, "TotalFlete", event)}
                                    readOnly
                                    value={model.TotalFlete ? model.TotalFlete : ""}
                                />
                                <button type="button"
                                    className="input-group-text" style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                    onClick={() => this.GuideUser('TotalFlete')}>
                                    <i className="fa fa-info-circle" />
                                </button>
                            </div>

                            {/* USO DE CFDI */}
                            {(model.TypeDoc && model.TypeDoc === 'T') &&
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend ">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Uso de CFDI</span>
                                    </div>
                                    <select className="form-control"
                                        disabled={action === 2 && !editMode}
                                        value={model?.UsoCFDI ?? ""}
                                        onChange={(event) => this.changeFieldModel(model, "UsoCFDI", event)}
                                    >
                                        <option value=''>Seleccione una opción</option>
                                        <option value="I07">Comunicaciones satelitales</option>
                                        <option value="I06">Comunicaciones telefónicas</option>
                                        <option value="I01">Construcciones</option>
                                        <option value="I05">Dados, troqueles, moldes, matrices y herramental</option>
                                        <option value="G02">Devoluciones, descuentos o bonificaciones</option>
                                        <option value="I04">Equipo de computo y accesorios</option>
                                        <option value="I03">Equipo de transporte</option>
                                        <option value="G03">Gastos en general</option>
                                        <option value="I02">Mobiliario y equipo de oficina por inversiones</option>
                                        <option value="I08">Otra maquinaria y equipo</option>
                                        <option value="S01">Sin efectos fiscales.</option>
                                    </select>
                                </div>
                            }

                            {/* Documentos de Timbrado */}
                            {model.U_FMB_UUID && model.U_FMB_UUID !== '' &&
                                <div >
                                    <div>
                                        <label className="btn float-left" onClick={() => this.DownloadDocCartaPorte('PDF')}><i className="fa fa-file-text-o"></i> Descargar PDF Carta Porte</label>
                                        <label className="btn float-left" onClick={() => this.DownloadDocCartaPorte('XML')}><i className="fa fa-file-text"></i> Descargar XML Carta Porte</label>
                                    </div>
                                </div>
                            }
                            {model.CanceledCFDI && model.CanceledCFDI === 'Y' &&
                                <div >
                                    <div>
                                        <label className="btn float-left" onClick={() => this.DownloadCancelationCartaPorte('PDF')}><i className="fa fa-file-text-o"></i> Descargar PDF Carta Porte cancelación</label>
                                    </div>
                                </div>
                            }
                        </div>
                        <br></br>
                    </div>
                    <br />

                    {/* Datos del receptor */}
                    {(model.TypeDoc && model.TypeDoc === 'I') &&
                        <>
                            <h4>Datos del receptor</h4>
                            <div className="row">
                                {/*PRIMER COLUMNA CARTA PORTE*/}
                                <div className="col-12 col-md-6">
                                    {/* CÓDIGO CLIENTE OPCIONAL */}
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend ">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Cliente</span>
                                        </div>
                                        <input type="text" className="form-control" id="txtPartner"
                                            disabled={action === 2 ? true : false}
                                            onKeyPress={(ev) => {
                                                if (ev.key === 'Enter' && !model.partnerSelected) {
                                                    this.openPartner();
                                                }
                                            }}
                                            onChange={(event) => this.changeFieldModel(model, "CardCode", event)}
                                            value={model.CardCode ? model.CardCode : ''}
                                        />
                                        {!(action === 2 && !editMode) &&
                                            <button type="button" className="input-group-text" style={{ backgroundColor: 'transparent', color: '#EABF28' }} onClick={this.openPartner}>
                                                <i className="fas fa-user fa-lg" />
                                            </button>
                                        }
                                    </div>

                                    {/* RFC */}
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend ">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">RUT</span>
                                        </div>
                                        <input type="text" className="form-control" id="txtPartner"
                                            disabled={action === 2 && !editMode}
                                            value={model.LicTradNum ? model.LicTradNum : ''}
                                            onChange={(event) => this.changeFieldModel(model, "LicTradNum", event)}
                                        />
                                    </div>

                                    {/* REGIMEN FISCAL */}
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend ">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Regimen Fiscal</span>
                                        </div>
                                        <select className="form-control"
                                            disabled={action === 2 && !editMode}
                                            value={model?.U_FMB_REGIMEN_FISCAL ?? ""}
                                            onChange={(event) => this.changeFieldModel(model, "U_FMB_REGIMEN_FISCAL", event)}
                                        >
                                            <option value=''>Seleccione un regimen fiscal</option>
                                            {regimenFiscal && regimenFiscal.length > 0 &&
                                                regimenFiscal.map((element) => {
                                                    return (
                                                        <option value={element?.FldValue}>{element.Descr ? element.Descr : ''}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                    </div>

                                    {/* MÉTODO DE PAGO */}
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend ">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Método de pago</span>
                                        </div>
                                        <select className="form-control"
                                            disabled={action === 2 && !editMode}
                                            value={model?.U_FMB_METODO_PAGO ?? "PPD"}
                                            onChange={(event) => this.changeFieldModel(model, "U_FMB_METODO_PAGO", event)}
                                        >
                                            <option value="PUE">Pago en una exhibición</option>
                                            <option value="PPD">Pago en parcialidades o diferido</option>
                                        </select>
                                    </div>
                                </div>

                                {/*SEGUNDA COLUMNA CARTA PORTE*/}
                                <div className="col-12 col-md-6">
                                    {/* NOMBRE DEL RECEPTOR */}
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend ">
                                            <span className="input-group-text font-weight-bold" id="Title-CP-CardName">Nombre</span>
                                        </div>
                                        <input type="text" className="form-control" id="CP-CardName" title="Nombre del receptor"
                                            disabled={action === 2 && !editMode}
                                            value={model.CardName ? model.CardName : ''}
                                            onChange={(event) => this.changeFieldModel(model, "CardName", event)}
                                        />
                                    </div>

                                    {/* CÓDIGO POSTAL */}
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend ">
                                            <span className="input-group-text font-weight-bold" id="Title-CP-ZipCode">Código Postal</span>
                                        </div>
                                        <input type="text" className="form-control" id="CP-ZipCode" title="Código postal"
                                            disabled={action === 2 && !editMode}
                                            value={model.ZipCode ? model.ZipCode : ''}
                                            onChange={(event) => this.changeFieldModel(model, "ZipCode", event)}
                                        />
                                    </div>

                                    {/* USO DE CFDI */}
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend ">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Uso de CFDI</span>
                                        </div>
                                        <select className="form-control"
                                            disabled={action === 2 && !editMode}
                                            value={model?.UsoCFDI ?? ""}
                                            onChange={(event) => this.changeFieldModel(model, "UsoCFDI", event)}
                                        >
                                            <option value=''>Seleccione una opción</option>
                                            <option value="I07">Comunicaciones satelitales</option>
                                            <option value="I06">Comunicaciones telefónicas</option>
                                            <option value="I01">Construcciones</option>
                                            <option value="I05">Dados, troqueles, moldes, matrices y herramental</option>
                                            <option value="G02">Devoluciones, descuentos o bonificaciones</option>
                                            <option value="I04">Equipo de computo y accesorios</option>
                                            <option value="I03">Equipo de transporte</option>
                                            <option value="G03">Gastos en general</option>
                                            <option value="I02">Mobiliario y equipo de oficina por inversiones</option>
                                            <option value="I08">Otra maquinaria y equipo</option>
                                            <option value="S01">Sin efectos fiscales.</option>
                                        </select>
                                    </div>

                                    {/* FORMA DE PAGO */}
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend ">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Forma de pago</span>
                                        </div>
                                        <select className="form-control"
                                            disabled={action === 2 && !editMode}
                                            value={model?.U_FMB_FORMA_PAGO ?? "99"}
                                            onChange={(event) => this.changeFieldModel(model, "U_FMB_FORMA_PAGO", event)}
                                        >
                                            <option value="01">Efectivo</option>
                                            <option value="02">Cheque nominativo</option>
                                            <option value="03">Transferencia electrónica de fondos</option>
                                            <option value="04">Tarjeta de crédito</option>
                                            <option value="05">Monedero electrónico</option>
                                            <option value="06">Dinero electrónico</option>
                                            <option value="08">Vales de despensa</option>
                                            <option value="12">Dación en pago</option>
                                            <option value="13">Pago por subrogación</option>
                                            <option value="14">Pago por consignación</option>
                                            <option value="15">Condonación</option>
                                            <option value="17">Compensación</option>
                                            <option value="23">Novación</option>
                                            <option value="24">Confusión</option>
                                            <option value="25">Remisión de deuda</option>
                                            <option value="26">Prescripción o caducidad</option>
                                            <option value="27">A satisfacción del acreedor</option>
                                            <option value="28">Tarjeta de débito</option>
                                            <option value="29">Tarjeta de servicios</option>
                                            <option value="30">Aplicación de anticipos</option>
                                            <option value="31">Intermediario pagos</option>
                                            <option value="99">Por definir</option>
                                        </select>
                                    </div>
                                </div>
                                <br></br>
                            </div>
                        </>
                    }
                </>
            );
        }

        return (
            <>
                <div className="row">
                    {/*PRIMER COLUMNA CARTA PORTE*/}
                    <div className="col-12 col-md-6">
                        {/*CÓDIGO CLIENTE OPCIONAL*/}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend ">
                                <span className="input-group-text font-weight-bold">Cliente</span>
                            </div>
                            <input
                                type="text"
                                className="form-control"
                                id="cardCodeCP"
                                name="cardCodeCP"
                                autocomplete="off" // added attribute to disable autocomplete
                                value={model.CardCode ? model.CardCode : ''}
                                disabled={action === 2 ? true : false}
                                onKeyPress={(ev) => {
                                    if (ev.key === 'Enter' && !model.partnerSelected) {
                                        this.openPartner();
                                    }
                                }}
                                onChange={(event) => this.changeFieldModel(model, "CardCode", event)}


                            />
                            {action === 1 && (
                                <button type="button" className="input-group-text" style={{ backgroundColor: 'transparent', color: '#EABF28' }} /*disabled={model.partnerSelected ? true : false}*/ onClick={this.openPartner}>
                                    <i className="fas fa-user fa-lg" />
                                </button>
                            )}
                        </div>

                        <div className="input-group mb-3">
                            <div className="input-group-prepend ">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Nombre</span>
                            </div>
                            <input type="text" className="form-control" id="txtPartner"
                                disabled={true}
                                value={model.CardName ? model.CardName : ''}
                            />
                        </div>

                        {/*Código CARTA PORTE*/}
                        {(action !== 1) &&
                            <div className="input-group mb-3">
                                <div className="input-group-prepend ">
                                    <span className="input-group-text font-weight-bold" id="txtPartner">Código</span>
                                </div>
                                <input type="text" className="form-control"
                                    id="txtCardCode"
                                    disabled={true}
                                    value={model.CodigoCarta ? model.CodigoCarta : ""}
                                />
                            </div>
                        }

                        {/* TranspInternac CARTA PORTE */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend ">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Sale del país</span>
                            </div>
                            <select
                                id="cartaPorteTranspInternac"
                                className="form-control"
                                disabled={action === 2 && !editMode}
                                value={model?.TranspInternac ?? ""}
                                onChange={(event) => this.ChangeTranspInternac(event.target.value)}
                            >
                                <option value=''>Seleccione una opción</option>
                                <option value='Si'>Si</option>
                                <option value='No'>No</option>
                            </select>
                            <button type="button"
                                className="input-group-text" style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                onClick={() => this.GuideUser('TranspInternac')}>
                                <i className="fa fa-info-circle" />
                            </button>
                        </div>

                        {/*PaisOrigenDestino CARTA PORTE*/}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend ">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">
                                    <span className="d-none d-xl-inline">Pais de Origen/Destino</span>
                                    <span className="d-inline d-xl-none">Pais Origen/Destino</span>
                                </span>
                            </div>
                            <select className="form-control"
                                id="txtTel1"
                                disabled={(action === 2 && !editMode) || (model.TranspInternac !== 'Si')}
                                onChange={(event) => this.changeFieldModel(model, "PaisOrigenDestino", event)}
                                value={model.PaisOrigenDestino ? model.PaisOrigenDestino.trim() : ""}
                            >
                                <option value=''>Seleccione una opción</option>
                                {countries && countries.length > 0 && countries.map((dato => {
                                    return (
                                        <option value={dato.c_Pais}>{dato.Nombre}</option>
                                    );
                                }))}
                            </select>
                        </div>

                        {/* USO DE CFDI */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend ">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Uso de CFDI</span>
                            </div>
                            <select
                                id="txtGroupCode"
                                className="form-control"
                                value={model?.UsoCFDI ?? ""}
                                onChange={(event) => this.changeFieldModel(model, "UsoCFDI", event)}
                                disabled={action === 2 && !editMode}>
                                <option value=''>Seleccione una opción</option>
                                <option value="I07">Comunicaciones satelitales</option>
                                <option value="I06">Comunicaciones telefónicas</option>
                                <option value="I01">Construcciones</option>
                                <option value="I05">Dados, troqueles, moldes, matrices y herramental</option>
                                <option value="G02">Devoluciones, descuentos o bonificaciones</option>
                                <option value="I04">Equipo de computo y accesorios</option>
                                <option value="I03">Equipo de transporte</option>
                                <option value="G03">Gastos en general</option>
                                <option value="I02">Mobiliario y equipo de oficina por inversiones</option>
                                <option value="I08">Otra maquinaria y equipo</option>
                                <option value="S01">Sin efectos fiscales.</option>
                            </select>
                        </div>
                    </div>

                    {/*SEGUNDA COLUMNA CARTA PORTE*/}
                    <div className="col-12 col-md-6">
                        {/*Version CARTA PORTE*/}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend ">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Version</span>
                            </div>
                            <select
                                id="cartaPorteVersion"
                                className="form-control"
                                value={model?.Version ?? ""}
                                onChange={(event) => this.ChangeVersionCartaPorte(event.target.value)}
                                disabled={true}
                            >
                                <option value=''>Seleccione una opción</option>
                                <option value='3.1'>3.1</option>
                                <option value='3.0'>3.0</option>
                                <option value='2.0'>2.0</option>
                            </select>
                        </div>

                        {/* IdCCP CARTA PORTE*/}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend ">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">IdCCP</span>
                            </div>
                            <input type=" text" className="form-control"
                                id="txt_IdCCP"
                                disabled={true}
                                value={model?.IdCCP ?? ''}
                            />
                            <button type="button"
                                className="input-group-text" style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                onClick={() => this.GuideUser('IdCCP')}>
                                <i className="fa fa-info-circle" />
                            </button>
                        </div>

                        {/*EntradaSalidaMerc CARTA PORTE*/}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend ">
                                <span className="input-group-text font-weight-bold">
                                    <span className="d-none d-xl-inline">Tipo de Entrada/Salida</span>
                                    <span className="d-inline d-xl-none">Tipo Entrada/Salida</span>
                                </span>
                            </div>
                            <select id="txtGroupCode" className="form-control"
                                value={model.EntradaSalidaMerc ? model.EntradaSalidaMerc.trim() : ""}
                                onChange={(event) => this.changeFieldModel(model, "EntradaSalidaMerc", event)}
                                disabled={(action === 2 && !editMode) || (model.TranspInternac !== 'Si')}
                            >
                                <option value=''>Seleccione una opción</option>
                                <option value='Entrada'>ENTRADA</option>
                                <option value='Salida'>SALIDA</option>
                            </select>
                        </div>

                        {/*ViaEntradaSalida CARTA PORTE*/}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend ">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">
                                    <span className="d-none d-xl-inline">Via de Entrada/Salida</span>
                                    <span className="d-inline d-xl-none">Vía Entrada/Salida</span>
                                </span>
                            </div>
                            <select id="txtGroupCode" className="form-control"
                                value={model.ViaEntradaSalida ? model.ViaEntradaSalida.trim() : ''}
                                onChange={(event) => this.changeFieldModel(model, "ViaEntradaSalida", event)}
                                disabled={(action === 2 && !editMode) || (model.TranspInternac !== 'Si')}
                            >
                                <option value=''>Seleccione una opción</option>
                                <option value='01'>01. Autotransporte</option>
                                {/* <option value='02'>02. Transporte Marítimo</option> */}
                                <option value='03'>03. Transporte Aéreo</option>
                                {/* <option value='04'>04. Transporte Ferroviario</option> */}
                            </select>
                        </div>

                        {/*TotalDistRec CARTA PORTE*/}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend ">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Distancia Total</span>
                            </div>
                            <input type=" text" className="form-control"
                                id="txtCardName"
                                disabled
                                onChange={(event) => this.changeFieldModel(model, "TotalDistRec", event)}
                                value={model.TotalDistRec ? model.TotalDistRec : "0.00"}
                            />
                            <button type="button"
                                className="input-group-text" style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                onClick={() => this.GuideUser('TotalDistRec')}>
                                <i className="fa fa-info-circle" />
                            </button>
                        </div>

                        {/* DocNum Flete */}
                        {model.DocNumFlete &&
                            <div className="input-group mb-3">
                                <div className="input-group-prepend ">
                                    <span className="input-group-text font-weight-bold" >N° Documento Flete</span>
                                </div>
                                <input
                                    id="docNumFlete"
                                    className="form-control"
                                    readOnly
                                    value={model.DocNumFlete} />
                            </div>
                        }

                        {/* Total Flete */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend ">
                                <span className="input-group-text font-weight-bold" >Total Flete</span>
                            </div>
                            <input type="number" className="form-control"
                                id="numberTotalFlete"
                                autoComplete="off"
                                // disabled={action === 2 ? true : false}
                                // disabled={true}
                                // onChange={(event) => this.changeFieldModel(model, "TotalFlete", event)}
                                readOnly
                                value={model.TotalFlete ? model.TotalFlete : ""}
                            />
                            <button type="button"
                                className="input-group-text" style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                onClick={() => this.GuideUser('TotalFlete')}>
                                <i className="fa fa-info-circle" />
                            </button>
                        </div>

                        {model.U_FMB_UUID && model.U_FMB_UUID !== '' &&
                            <div >
                                <div>
                                    <label className="btn float-left" onClick={() => this.DownloadDocCartaPorte('PDF')}><i className="fa fa-file-text-o"></i> Descargar PDF Carta Porte</label>
                                    <label className="btn float-left" onClick={() => this.DownloadDocCartaPorte('XML')}><i className="fa fa-file-text"></i> Descargar XML Carta Porte</label>
                                </div>
                            </div>
                        }

                        {model.CanceledCFDI && model.CanceledCFDI === 'Y' &&
                            <div >
                                <div>
                                    <label className="btn float-left" onClick={() => this.DownloadCancelationCartaPorte('PDF')}><i className="fa fa-file-text-o"></i> Descargar PDF Carta Porte cancelación</label>
                                    {/* <label className="btn float-left" onClick={() => this.DownloadDocCartaPorte('XML')}><i className="fa fa-file-text"></i> Descargar XML Carta Porte cancelación</label> */}
                                </div>
                            </div>
                        }
                    </div>
                    <br></br>
                </div>
                <div className="row">
                    {/*PRIMER COLUMNA CARTA PORTE*/}
                    <div className="col-12 col-md-6">
                        {/* TranspInternac CARTA PORTE */}
                        {/* <div className="input-group mb-3">
                            <div class="input-group-prepend ">
                                <span class="input-group-text font-weight-bold" id="basic-addon1">TRASH</span>
                            </div>
                            <select
                                id="cartaPorteTranspInternac"
                                class="form-control"
                                value={model?.TranspInternac ?? ""}
                                onChange={(event) => this.ChangeVersionCartaPorte(event.target.value)}
                                disabled={true}
                            >
                                <option value=''>Seleccione una opción</option>
                                <option value='Si'>Si</option>
                                <option value='No'>No</option>
                            </select>
                            <button type="button"
                                class="input-group-text" style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                onClick={() => this.GuideUser('TranspInternac')}>
                                <i class="fa fa-info-circle" />
                            </button>
                        </div> */}
                    </div>

                    {/*SEGUNDA COLUMNA CARTA PORTE*/}
                    <div className="col-12 col-md-6">
                        {/*Version CARTA PORTE*/}
                        {/* <div className="input-group mb-3">
                            <div class="input-group-prepend ">
                                <span class="input-group-text font-weight-bold" id="basic-addon1">Version</span>
                            </div>
                            <input type=" text" className="form-control"
                                id="txtCardName"
                                disabled={true}
                                onChange={(event) => this.changeFieldModel(model, "Version", event)}
                                value={model.Version ? model.Version.trim() : ""}
                            />
                        </div> */}


                    </div>
                    <br></br>
                </div>
            </>
        )
    }

    renderPorteBody = () => {
        const { model, action } = this.props;
        const {
            editMode,
            autotransporte,
            figuraTransporte,
            unidadPeso,
            UnidadConcepts,
            usoInterno,
        } = this.state;

        const selectedTransporte = autotransporte?.find(({ Codigo, TipoTransporte }) => Number(Codigo) === Number(model.Transporte) && TipoTransporte === model.TipoTransporte) ?? {};
        const selectedFiguraTransporte = figuraTransporte?.find(({ CodigoFiguraTransporte }) => Number(CodigoFiguraTransporte) === Number(model.FiguraTransporte)) ?? {};
        return (
            <div style={{ marginTop: 30 }}>
                <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        {/* Mercancias */}
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary active"
                            id="nav-CartaPorte-Mercancias"
                            data-toggle="tab"
                            href="#Section-CartaPorte-Mercancias">
                            Mercancias
                        </a>
                        {/* Conceptos */}
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-CartaPorte-Conceptos"
                            data-toggle="tab"
                            href="#Section-CartaPorte-Conceptos">
                            Conceptos
                        </a>
                        {/* Transporte */}
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-CartaPorte-Transporte"
                            data-toggle="tab"
                            href="#Section-CartaPorte-Transporte"
                        >
                            Transporte
                        </a>
                        {/* Figura Transporte */}
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-CartaPorte-FiguraTransporte"
                            data-toggle="tab"
                            href="#Section-CartaPorte-FiguraTransporte"
                        >
                            Figura Transporte
                        </a>
                        {/* Ubicaciones */}
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary"
                            id="nav-CartaPorte-Ubicaciones"
                            data-toggle="tab"
                            href="#Section-CartaPorte-Ubicaciones"
                        >
                            Ubicaciones
                        </a>
                        {/* CFDI Relacionados */}
                        {model.CanceledCFDI && model.CanceledCFDI === 'Y' &&
                            <a
                                className="nav-item nav-link font-weight-bold text-secondary"
                                id="nav-CartaPorte-CFDIRelacionados"
                                data-toggle="tab"
                                href="#Section-CartaPorte-CFDIRelacionados"
                            >
                                CFDI Relacionados
                            </a>
                        }
                    </div>
                </nav>
                <div className="tab-content" style={{ textAlign: 'left' }}>
                    {/* APARTADO MERCANCÍAS */}
                    <div className="container tab-pane active" id="Section-CartaPorte-Mercancias" aria-labelledby="nav-CartaPorte-Mercancias">
                        <div style={{ marginTop: 30 }}>
                            <nav>
                                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                    <a
                                        className="nav-item nav-link font-weight-bold text-secondary active "
                                        id="nav-CartaPorte-tab-Mercancia"
                                        data-toggle="tab"
                                        href="#Mercancia"
                                    // role="mercancia"
                                    // aria-controls="Mercancia"
                                    // aria-selected="true"
                                    >
                                        Mercancia
                                    </a>
                                    <a
                                        className="nav-item nav-link font-weight-bold text-secondary"
                                        id="nav-CartaPorte-tab-DatosGeneralesMe"
                                        data-toggle="tab"
                                        href="#DatosGeneralesMe"
                                    // role="datosGeneralesMe"
                                    // aria-controls="DatosGeneralesMe"
                                    // aria-selected="false"
                                    >
                                        Datos Generales
                                    </a>

                                </div>
                            </nav>
                            <div className="tab-content" style={{ textAlign: 'left' }}>
                                {/* SUB-APARTADO DatosGeneralesMe */}
                                <div className="container tab-pane fade" id="DatosGeneralesMe" role="datosGeneralesMe" aria-labelledby="nav-CartaPorte-tab-DatosGeneralesMe">
                                    <div className="row">
                                        {/*Primera columna*/}
                                        <div className="col-12 col-md-6"><br></br>
                                            {/*PesoBrutoTotal CARTA PORTE*/}
                                            {/*newPorteFields[25] !== undefined && newPorteFields[25].value &&*/ <div className="input-group mb-3">
                                                <div className="input-group-prepend ">
                                                    <span className="input-group-text font-weight-bold">
                                                        <span className="d-none d-xl-inline">PesoBrutoTotal</span>
                                                        <span className="d-inline d-xl-none">Peso Bruto</span>
                                                    </span>
                                                </div>
                                                <input type="text" className="form-control"
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        borderColor: '#ced4da',
                                                        color: '#000'
                                                    }}
                                                    id="txtTel1"
                                                    disabled={action === 2 && !editMode}
                                                    onChange={(event) => this.changeFieldModel(model, "PesoBrutoTotal", event)}
                                                    value={model.PesoBrutoTotal ? model.PesoBrutoTotal : "0.00"}
                                                />
                                            </div>}

                                            {/*PesoNetoTotal CARTA PORTE*/}
                                            {/*newPorteFields[26] !== undefined && newPorteFields[26].value &&*/ <div className="input-group mb-3">
                                                <div className="input-group-prepend ">
                                                    <span className="input-group-text font-weight-bold">
                                                        <span className="d-none d-xl-inline">PesoNetoTotal</span>
                                                        <span className="d-inline d-xl-none">Peso Neto</span>
                                                    </span>
                                                </div>
                                                <input type="text" className="form-control"
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        borderColor: '#ced4da',
                                                        color: '#000'
                                                    }}
                                                    id="txtTel1"
                                                    disabled={action === 2 && !editMode}
                                                    onChange={(event) => this.changeFieldModel(model, "PesoNetoTotal", event)}
                                                    value={model.PesoNetoTotal ? model.PesoNetoTotal : "0.00"}
                                                />
                                            </div>}

                                            {/*CargoPorTasacion CARTA PORTE*/}
                                            {/*newPorteFields[27] !== undefined && newPorteFields[27].value &&*/ <div className="input-group mb-3">
                                                <div className="input-group-prepend ">
                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                        <span className="d-none d-xl-inline">CargoPorTasacion</span>
                                                        <span className="d-inline d-xl-none">Cargo</span>
                                                    </span>
                                                </div>
                                                <input type="text" className="form-control"
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        borderColor: '#ced4da',
                                                        color: '#000'
                                                    }}
                                                    id="txtTel1"
                                                    disabled={action === 2 && !editMode}
                                                    onChange={(event) => this.changeFieldModel(model, "CargoPorTasacion", event)}
                                                    value={model.CargoPorTasacion ? model.CargoPorTasacion : 0.00}
                                                />
                                            </div>}
                                        </div>

                                        {/*Segunda columna*/}
                                        <div className="col-12 col-md-6"><br></br>
                                            {/*UnidadPeso CARTA PORTE*/}
                                            {/*newPorteFields[28] !== undefined && newPorteFields[28].value &&*/ <div className="input-group mb-3">
                                                <div className="input-group-prepend ">
                                                    <span className="input-group-text font-weight-bold">
                                                        <span className="d-none d-xl-inline">UnidadPeso</span>
                                                        <span className="d-inline d-xl-none">Unidad Peso</span>
                                                    </span>
                                                </div>
                                                <select id="txtGroupCode" className="form-control btn-outline-secondary"
                                                    value={model.UnidadPeso ? model.UnidadPeso.trim() : "KGM"}
                                                    onChange={(event) => this.changeFieldModel(model, "UnidadPeso", event)}
                                                    disabled={action === 2 && !editMode}
                                                    style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}>
                                                    <option value=''>Seleccione una opción</option>
                                                    {unidadPeso.length > 0 && unidadPeso.map((dato => {
                                                        return (
                                                            <option value={dato.Clave}>{`${dato.Clave} (${dato.Simbolo})    -   ${dato.Nombre}`}</option>
                                                        );
                                                    }))}
                                                </select>
                                            </div>}

                                            {/*NumTotalMercancias CARTA PORTE*/}
                                            {/*newPorteFields[29] !== undefined && newPorteFields[29].value &&*/ <div className="input-group mb-3">
                                                <div className="input-group-prepend ">
                                                    <span className="input-group-text font-weight-bold">
                                                        <span className="d-none d-xl-inline">NumTotalMercancias</span>
                                                        <span className="d-inline d-xl-none">Núm Mercancías</span>
                                                    </span>
                                                </div>
                                                <input type="text" className="form-control"
                                                    style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                                    id="txtTel1"
                                                    disabled={action === 2 && !editMode}
                                                    onChange={(event) => this.changeFieldModel(model, "NumTotalMercancias", event)}
                                                    value={model.NumTotalMercancias ? model.NumTotalMercancias : ""}
                                                />
                                            </div>}
                                        </div>
                                    </div>
                                </div>

                                {/* SUB-APARTADO MERCANCIA */}
                                <div className="w-100 table-scroll tab-pane active" id="Mercancia" role="mercancia" aria-labelledby="nav-CartaPorte-tab-Mercancia" style={{/*maxHeight: 500*/ paddingTop: 5 }}>
                                    <table
                                        id="dataTableDocuments"
                                        className="display"
                                        style={{ width: '100%', marginBottom: 40, marginRight: -3000 }}>
                                        <thead className="table-header-yellow">
                                            <tr>
                                                <td className="sticky-columns">#</td>
                                                <td className="sticky-columns">ClaveProdServ</td>
                                                <td style={{ textAlign: 'center' }}>Folio</td>
                                                <td style={{ textAlign: 'center' }}>Cantidad</td>
                                                <td style={{ textAlign: 'center' }}>Descripcion</td>
                                                <td style={{ textAlign: 'center' }}>Unidad</td>
                                                <td style={{ textAlign: 'center' }}>PesoEnKg</td>
                                                <td style={{ textAlign: 'center' }}>ValorMercancia</td>
                                                <td style={{ textAlign: 'center' }}>Moneda</td>
                                                <td className="sticky-columns p-0">
                                                    {/* Sub tabla para las acciones */}
                                                    <table>
                                                        <tr>
                                                            <td className='table-header-yellow' style={{ textAlign: 'center' }}>
                                                                <div style={{ width: 110 }}>Acciones</div>
                                                            </td>
                                                            {!(action === 2 && !editMode) && model.TypeDoc === 'I' &&
                                                                <td className='table-header-yellow' style={{ textAlign: 'center' }}>
                                                                    <div style={{ width: 90 }}>Eliminar</div>
                                                                </td>
                                                            }
                                                        </tr>
                                                    </table>
                                                </td>
                                                {/* <td class="sticky-columns" style={{ textAlign: 'center' }}></td> */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {model.Mercancias && model.Mercancias.length > 0 && model.Mercancias.map((item, index) => {
                                                return (
                                                    <tr>
                                                        <td className="sticky-columns">{index + 1}</td>
                                                        <td className="sticky-columns">{item.claveProdServ ? item.claveProdServ : item.BienesTransp ? item.BienesTransp : 'N/A'}</td>
                                                        <td className="sticky-columns">{item.NumAtCard ? item.NumAtCard : 'Sin Folio'}</td>
                                                        <td style={{ textAlign: 'center' }}>
                                                            {!(action === 2 && !editMode) ?
                                                                <input
                                                                    type="text"
                                                                    className=" form-control validarCant cantBlur btn-outline-secondary"
                                                                    style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000', paddingTop: 1, paddingBottom: 2, width: 100, textAlign: "center", }}
                                                                    step="any"
                                                                    id={'itemCantidadMercanciaPorte' + index}
                                                                    value={item.Cantidad ?? 1}
                                                                    onChange={event => this.ChangeQuantityMercancia(event.target.value, index)}
                                                                />
                                                                :
                                                                item.Cantidad ? Number(item.Cantidad).toFixed(2) : '1.00'
                                                            }
                                                        </td>
                                                        <td style={{ textAlign: 'center' }}>{item.Descripcion ? item.Descripcion : ''}</td>
                                                        <td style={{ textAlign: 'center' }}>{item.ClaveUnidad + ", " + item.Unidad}</td>
                                                        <td style={{ textAlign: 'center' }}>{item.PesoEnKg ? item.PesoEnKg : ''}</td>
                                                        <td style={{ textAlign: 'center' }}>{CURRENCY + ' ' + formatNumber.new(item.ValorMercancia ? item.ValorMercancia : '')}</td>
                                                        <td style={{ textAlign: 'center' }}>{item.Moneda ? item.Moneda : ''}</td>
                                                        <td className="sticky-columns p-0">
                                                            {/* Sub tabla para las acciones */}
                                                            <table>
                                                                <tr>
                                                                    <td style={{ backgroundColor: item.LineStatus ? 'rgb(210,210,210)' : '#FFF', textAlign: 'center', width: 300 }}>
                                                                        <div style={{ width: 110 }}>
                                                                            <button type="button" className="btn btn-timbra-one btn-sm botonCorrect"
                                                                                onClick={() => this.openItemDetail(item)}
                                                                                style={{ fontWeight: '500' }}>
                                                                                <i className="far fa-file-alt">
                                                                                </i> Ver Detalles
                                                                            </button>
                                                                        </div>
                                                                    </td>
                                                                    {!(action === 2 && !editMode) && (model.TypeDoc === 'I' || usoInterno) &&
                                                                        <td style={{ backgroundColor: item.LineStatus ? 'rgb(210,210,210)' : '#FFF', textAlign: 'center', width: 300 }}>
                                                                            <div style={{ width: 90 }}>
                                                                                <button
                                                                                    type="button"
                                                                                    style={{ backgroundColor: 'transparent', padding: 5, color: '#c42222', paddingTop: 2, paddingBottom: 2, }}
                                                                                    className="btn"
                                                                                    onClick={() => this.deleteItem(index, item.DocEntry)}>
                                                                                    <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                                                </button>
                                                                            </div>
                                                                        </td>
                                                                    }
                                                                </tr>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                            <tr>
                                                <td></td>
                                                <td
                                                    className="sticky-column"
                                                    style={{ backgroundColor: '#FFF', textAlign: 'center' }}>
                                                    {(action === 1 || (editMode && (model.TypeDoc === 'I' || usoInterno))) && (
                                                        !usoInterno ?
                                                            <button type="button" style={{ backgroundColor: 'transparent', padding: 5, color: 'green', }} className="btn" onClick={this.openInvoicePaymentList}>
                                                                <i className="fa fa-plus-circle" aria-hidden="true" size="10" />
                                                            </button>
                                                            :
                                                            <button type="button" style={{ backgroundColor: 'transparent', padding: 5, color: 'green', }} className="btn" onClick={() => this.openNewItem()}>
                                                                <i className="fa fa-plus-circle" aria-hidden="true" size="10" />
                                                            </button>
                                                    )}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* APARTADO CONCEPTOS */}
                    <div className="container tab-pane fade" id="Section-CartaPorte-Conceptos" aria-labelledby="nav-CartaPorte-Conceptos">
                        <div style={{ marginTop: 30 }}>
                            <div className="w-100 table-scroll tab-pane " style={{ textAlign: 'left' }}>
                                <table id="dataTableDocuments" className="display" style={{ width: '100%', marginBottom: 40, marginRight: -3000 }}>
                                    <thead className="table-header-yellow">
                                        <tr>

                                            <td className="sticky-columns">Cantidad</td>
                                            <td className="sticky-columns">Unidad</td>
                                            <td style={{ textAlign: 'center' }}>Cod. Prod. SAT (Search)</td>
                                            <td style={{ textAlign: 'center' }}>Concepto</td>
                                            <td style={{ textAlign: 'center' }}>Precio Unitario</td>
                                            <td style={{ textAlign: 'center' }}>Descuento %</td>
                                            <td style={{ textAlign: 'center' }}>Objeto de impuesto</td>
                                            <td style={{ textAlign: 'center' }}>No. Identificacion</td>

                                            <td className="sticky-columns"></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {model.Concepts && model.Concepts.length > 0 && model.Concepts.map((element, indexLine) => {
                                            return (
                                                <tr>
                                                    {/* CANTIDAD */}
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className=" form-control validarCant cantBlur btn-outline-secondary"
                                                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000', paddingTop: 1, paddingBottom: 2, width: "13vh", textAlign: "center" }}
                                                            id={'cantidad' + indexLine}
                                                            value={element?.Cantidad ?? ''}
                                                            min={0}
                                                            disabled={(action === 2) && !editMode ? true : false}
                                                            onChange={event => this.ChangeQtyConcept(event.target.value, indexLine)}
                                                        />
                                                    </td>
                                                    {/* UNIDAD */}
                                                    <td>
                                                        <select className="form-control" style={{ width: "auto" }}
                                                            onChange={(event) => this.ChangeUnityConcept(event.target.value, indexLine)}
                                                            value={element.ShowUnidad ?? ""}
                                                            disabled={(action === 2) && !editMode ? true : false}
                                                        >

                                                            {UnidadConcepts.length > 0 &&
                                                                UnidadConcepts.map(((unityConcept) => {
                                                                    return (
                                                                        <option value={`${unityConcept?.Clave ?? ''},${unityConcept?.Nombre},${indexLine}`}>{unityConcept?.Nombre ?? ''}</option>
                                                                    );
                                                                }))}
                                                        </select>
                                                    </td>
                                                    {/* CODIGO PRODUCTO SERVICIO */}
                                                    <td style={{ textAlign: 'center' }}>
                                                        <div className='input-group'>
                                                            <input
                                                                type=" text"
                                                                disabled={(action === 2) && !editMode ? true : false}
                                                                placeholder="Código Producto SAT"
                                                                className=" form-control validarCant cantBlur btn-outline text-center"
                                                                style={{ backgroundColor: element?.whsSelected ? 'rgb(248,242,209)' : 'transparent', color: '#000', paddingTop: 1, paddingBottom: 2, }}
                                                                value={element?.ClaveProdServ ?? ''}
                                                                onChange={event => this.ChangeCodProdSAT(event.target.value, indexLine)}
                                                            />
                                                            <div className="input-group-append" >
                                                                <button
                                                                    type="button"
                                                                    disabled={(action === 2) && !editMode ? true : false}
                                                                    style={{ backgroundColor: 'transparent', color: '#EABF28', paddingTop: 2, paddingBottom: 2, border: "1px solid #ced4da" }}
                                                                    className="btn btn-outline-secondary"
                                                                    onClick={() => this.OpenClaveProdSAT(indexLine, -1)}
                                                                >
                                                                    <i className="fa fa-list" aria-hidden="true" />
                                                                </button>
                                                            </div>

                                                        </div>
                                                    </td>
                                                    {/* DESCRIPTION */}
                                                    <td>
                                                        <input
                                                            type=" text"
                                                            disabled={(action === 2) && !editMode ? true : false}
                                                            className="form-control btn-outline-secondary"
                                                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000', height: 'auto', width: '30vh' }}
                                                            onChange={event => this.ChangeConceptDescription(event.target.value, indexLine)}
                                                            value={element?.Descripcion ?? ''}
                                                        />
                                                    </td>
                                                    {/* PRECIO UNITARIO */}
                                                    <td>
                                                        <input
                                                            type="text"
                                                            disabled={(action === 2) && !editMode ? true : false}
                                                            className=" form-control validarCant cantBlur btn-outline-secondary"
                                                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000', paddingTop: 1, paddingBottom: 2, width: 'auto', textAlign: "center", }}
                                                            id={'cantidad' + indexLine}
                                                            value={element?.ValorUnitario ?? 0.0}
                                                            onChange={event => this.ChangeConceptValorUnitario(event.target.value, indexLine)}
                                                        />
                                                    </td>
                                                    {/* DESCUENTO */}
                                                    <td>
                                                        <input
                                                            type="text"
                                                            disabled={(action === 2) && !editMode ? true : false}
                                                            className=" form-control validarCant cantBlur btn-outline-secondary"
                                                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000', paddingTop: 1, paddingBottom: 2, width: 'auto', textAlign: "center", }}
                                                            id={'cantidad' + indexLine}
                                                            value={element?.Descuento ?? 0.0}
                                                            onChange={event => this.ChangeDescuento(event.target.value, indexLine)}
                                                        />
                                                    </td>

                                                    {/* OBJETO DE IMPUESTO */}
                                                    <td>
                                                        <select className="form-control" style={{ width: "auto" }}
                                                            disabled={model?.TypeDoc === 'I' ? false : true}
                                                            onChange={(event) => this.ChangeObjImpuesto(event.target.value, indexLine)}
                                                            value={element.ObjetoImp ?? ""}
                                                        >
                                                            <option value='01'>No objeto de impuesto.</option>
                                                            <option value='02'>Sí objeto de impuesto.</option>
                                                            <option value='03'>Sí objeto del impuesto y no obligado al desglose.</option>
                                                            <option value='04'>Si objeto del impuesto y no causa impuesto</option>
                                                        </select>
                                                    </td>

                                                    {/* NUMERO DE IDENTIFICACIÓN */}
                                                    <td className="sticky-column" >
                                                        <input
                                                            type="text"
                                                            disabled={(action === 2) && !editMode ? true : false}
                                                            className="form-control btn-outline-secondary"
                                                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000', height: 'auto', width: '30vh' }}
                                                            onChange={event => this.ChangeNoIdentification(event.target.value, indexLine)}
                                                            value={element?.NoIdentificacion ?? ''}
                                                        />
                                                    </td>

                                                    {/* RETENER */}
                                                    {/* <td>
                                                        <select className="form-control" style={{ width: "auto" }}
                                                            onChange={(event) => this.ChangeObjImpuesto(event.target.value, indexLine)}
                                                            value={element.ObjetoImp ?? ""}
                                                        >
                                                            <option value='01'>No objeto de impuesto.</option>
                                                            <option value='02'>Sí objeto de impuesto.</option>
                                                            <option value='03'>Sí objeto del impuesto y no obligado al desglose.</option>
                                                            <option value='04'>Si objeto del impuesto y no causa impuesto</option>
                                                        </select>
                                                    </td> */}


                                                    {/* ESTO SI SE VA A OCUPAR O NO SE SI YA LO TENGA EL PETER XD */}
                                                    {/* IVA
                                                    <td>
                                                        <select className="form-control" style={{ width: "auto" }}
                                                            onChange={(event) => this.ChangeUnityConcept(event.target.value, indexLine)}
                                                            value={element.ShowUnidad ?? ""}
                                                        >
                                                            <option value='0'>Sin IVA</option>
                                                            <option value='1'>Exento de IVA</option>
                                                            <option value='2'>Tasa Cero</option>
                                                            <option value='3'>Tasa del 8 %</option>
                                                            <option value='4'>Tasa del 16 %</option>
                                                        </select>
                                                    </td>

                                                    RETENER
                                                    <td>
                                                        <select className="form-control" style={{ width: "auto" }}
                                                            onChange={(event) => this.(event.target.value, indexLine)}
                                                            value={element.RetenerISR ?? ""}
                                                        >
                                                            <option value='-1'>Seleccione (opcional)</option>
                                                            <option value='10'>ISR 10 %</option>
                                                            <option value='20'>ISR 20 %</option>
                                                            <option value='1.25'>ISR 1.25 % RESICO</option>
                                                        </select>
                                                    </td>

                                                    RETENER ISR
                                                    <td>
                                                        <select className="form-control" style={{ width: "auto" }}
                                                            onChange={(event) => this.(event.target.value, indexLine)}
                                                            value={element.RetenerISR ?? ""}
                                                        >
                                                            <option value='-1'>Seleccione (opcional)</option>
                                                            <option value='10'>ISR 10 %</option>
                                                            <option value='20'>ISR 20 %</option>
                                                            <option value='1.25'>ISR 1.25 % RESICO</option>
                                                        </select>
                                                    </td> */}


                                                    {/* <td style={{ textAlign: 'center' }}>
                                                        <button type="button" className="btn btn-timbra-one btn-sm botonCorrect"
                                                            onClick={() => this.openAddressDetail(element, indexLine)}
                                                            style={{ fontWeight: '500' }}>
                                                            <i class="far fa-file-alt"></i> Ver Detalles
                                                        </button>
                                                    </td> */}
                                                    <td className="sticky-column" style={{ backgroundColor: '#FFF', textAlign: 'center' }}>
                                                        <button type="button"
                                                            style={{ backgroundColor: 'transparent', padding: 5, color: 'red', }}
                                                            className="btn"
                                                            onClick={() => this.RemoveConcept(indexLine)}
                                                        >
                                                            <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                        </button>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                        <tr>
                                            <td className="sticky-column" style={{ backgroundColor: '#FFF', textAlign: 'center' }}>
                                                {(Number(action) === 1 || (Number(action) === 2 && editMode)) && (
                                                    <button type="button" style={{ backgroundColor: 'transparent', padding: 5, color: 'green', }} className="btn" onClick={this.AddConceptLine} >
                                                        <i className="fa fa-plus-circle" aria-hidden="true" size="10" />
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    {/* APARTADO UBICACIONES */}
                    <div className="container tab-pane fade" id="Section-CartaPorte-Ubicaciones" aria-labelledby="nav-CartaPorte-Ubicaciones">
                        <div style={{ marginTop: 30 }}>
                            <div className="w-100 table-scroll tab-pane " style={{ textAlign: 'left' }}>
                                <table
                                    id="dataTableDocuments"
                                    className="display"
                                    style={{ width: '100%', marginBottom: 40, marginRight: -3000 }}>
                                    <thead className="table-header-yellow">
                                        <tr>
                                            <td className="sticky-columns">Tipo Ubicacion</td>
                                            <td style={{ textAlign: 'center' }}>ID Ubicacion</td>
                                            <td style={{ textAlign: 'center' }}>RUT Remitente/Destinatario</td>
                                            <td style={{ textAlign: 'center' }}>Codigo Postal</td>
                                            <td style={{ textAlign: 'center' }}>Pais</td>
                                            <td className="sticky-columns">Acciones</td>
                                            {!(action === 2 && !editMode) &&
                                                <td className="sticky-columns">Eliminar</td>
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {model.Ubicaciones && Array.isArray(model.Ubicaciones) && model.Ubicaciones.length > 0 && model.Ubicaciones.map((element, index) => {

                                            return (
                                                // element.TipoUbicacion === 'Destino' &&
                                                <tr>
                                                    <td className="sticky-columns">{element.TipoUbicacion ? element.TipoUbicacion : ''}</td>
                                                    <td style={{ textAlign: 'center' }}>{element.IDUbicacion ? element.IDUbicacion : 'S/I'}</td>
                                                    <td style={{ textAlign: 'center' }}>{element.RFCRemitenteDestinatario ? element.RFCRemitenteDestinatario : ''}</td>
                                                    <td style={{ textAlign: 'center' }}>{element.CodigoPostal}</td>
                                                    <td style={{ textAlign: 'center' }}>{element.Pais ? element.Pais : ''}</td>
                                                    <td className="sticky-columns">
                                                        <button type="button" className="btn btn-timbra-one btn-sm botonCorrect"
                                                            onClick={() => this.openAddressDetail(element, index)}
                                                            style={{ fontWeight: '500' }}>
                                                            <i className="far fa-file-alt"></i> Ver Detalles
                                                        </button>
                                                    </td>
                                                    {!(action === 2 && !editMode) &&
                                                        <td className="sticky-column" style={{ backgroundColor: '#FFF', textAlign: 'center' }}>
                                                            <button type="button" style={{ backgroundColor: 'transparent', padding: 5, color: 'red' }} className="btn" onClick={() => this.removeAddressElement(index)} >
                                                                <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                            </button>
                                                        </td>
                                                    }
                                                </tr>
                                            );
                                        })}
                                        <tr>
                                            <td
                                                className="sticky-column"
                                                style={{ backgroundColor: '#FFF', textAlign: 'center' }}>
                                                {!(action === 2 && !editMode) && (
                                                    <button type="button" style={{ backgroundColor: 'transparent', padding: 5, color: 'green', }} className="btn" onClick={this.addAddressElement} >
                                                        <i className="fa fa-plus-circle" aria-hidden="true" size="10" />
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    {/* APARTADO AUTO TRANSPORTE */}
                    <div className="container tab-pane fade" id="Section-CartaPorte-Transporte" aria-labelledby="nav-CartaPorte-Transporte">
                        <div className="row">
                            <div className="col-12 col-md-6"><br></br>
                                {/*CÓDIGO Transporte*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend ">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Código de Transporte</span>
                                            <span className="d-inline d-xl-none">Código Transporte</span>
                                        </span>
                                    </div>
                                    {/* <select className="form-control"
                                        disabled={(action === 2) && !editMode ? true : false}
                                        onChange={(event) => this.changeFieldModel(model, "Transporte", event)}
                                        value={model.Transporte ? model.Transporte + '|' + model.TipoTransporte: ""}
                                    >
                                        <option value=''>Seleccione una opción</option>
                                        {autotransporte.length > 0 && autotransporte.map((dato => {
                                            return (
                                                // V1
                                                // <option value={dato.Codigo + '|' + dato.TipoTransporte}>{`CódigoUnidad: ${dato.CodigoUnidad || ''}    -   TipodeUnidad: ${dato.TipodeUnidad || ''}`}</option>
                                                <option value={dato.Codigo + '|' + dato.TipoTransporte}>{`${dato.TipodeUnidad || ''}    -   Placa: ${dato.PlacaVM || ''}`}</option>
                                            );
                                        }))}
                                    </select> */}
                                    <input type="text" className="form-control" id="codeTransporte" title="Código de Transporte" disabled
                                        value={selectedTransporte.TipodeUnidad && selectedTransporte.TipodeUnidad !== '' ? selectedTransporte.TipodeUnidad + ' - Placa: ' + selectedTransporte.PlacaVM : ''} />
                                    {!(action === 2 && !editMode) &&
                                        <button
                                            type="button"
                                            style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                            className="input-group-text" title="Buscar Transportes"
                                            onClick={this.searchTransporte}
                                        >
                                            <i className="fas fa-search fa-lg" />
                                        </button>
                                    }
                                </div>
                            </div>
                            {/*Segunda columna*/}
                            <div className="col-12 col-md-6"><br></br>
                                {/*VerDetalles Transporte*/}
                                <div className="input-group mb-3">
                                    <button type="button" className="btn botonCerrar text-white" onClick={() => this.openTransporte({ tipoTransporte: model.TipoTransporte, Code: model.Transporte, index: model.Transporte })}>Ver detalles</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* APARTADO FIGURA TRANSPORTE */}
                    <div className="container tab-pane fade" id="Section-CartaPorte-FiguraTransporte" aria-labelledby="nav-CartaPorte-FiguraTransporte">
                        <div className="row">
                            <div className="col-12 col-md-6"><br></br>
                                {/*CÓDIGO FiguraTransporte*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend ">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Figura de Transporte</span>
                                            <span className="d-inline d-xl-none">Figura Transporte</span>
                                        </span>
                                    </div>
                                    {/* <select className="form-control"
                                        id="txtTel1"
                                        disabled={(action === 2) && !editMode ? true : false}
                                        onChange={(event) => this.changeFieldModel(model, "FiguraTransporte", event)}
                                        value={model.FiguraTransporte ? model.FiguraTransporte : ""}
                                    >
                                        <option value=''>Seleccione una opción</option>
                                        {figuraTransporte.length > 0 && figuraTransporte.map((element => {
                                            return (
                                                // V1
                                                // <option value={element.CodigoFiguraTransporte}>{`Código: ${element.CodigoFiguraTransporte}  -   TipoFigura: ${changeTipoFigura(element.TipoFigura.trim())}`}</option>
                                                <option value={element.CodigoFiguraTransporte}>{`${element.NombreFigura}  -   ${changeTipoFigura(element.TipoFigura.trim())}`}</option>
                                            );
                                        }))}
                                    </select> */}
                                    <input type="text" className="form-control" id="codeFiguraTransporte" title="Código de la Figura de Transporte" disabled
                                        value={selectedFiguraTransporte.CodigoFiguraTransporte && selectedFiguraTransporte.CodigoFiguraTransporte !== '' ? selectedFiguraTransporte.NombreFigura + ' - ' + changeTipoFigura(selectedFiguraTransporte.TipoFigura.trim()) : ''} />
                                    {!(action === 2 && !editMode) &&
                                        <button
                                            type="button"
                                            style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                            className="input-group-text" title="Buscar Transportes"
                                            onClick={this.searchFiguraTransporte}
                                        >
                                            <i className="fas fa-search fa-lg" />
                                        </button>
                                    }
                                </div>
                            </div>
                            {/*Segunda columna*/}
                            <div className="col-12 col-md-6"><br></br>
                                {/*VerDetalles DRIVER MANAGER*/}
                                <div className="input-group mb-3">
                                    <button type="button" className="btn botonCerrar text-white" onClick={() => this.openFiguraTrans({ Code: model.FiguraTransporte, index: model.FiguraTransporte })}>Ver detalles</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* APARTADO CFDI RELACIONADOS */}
                    <div className="container tab-pane fade" id="Section-CartaPorte-CFDIRelacionados" aria-labelledby="nav-CartaPorte-CFDIRelacionados">
                        {/*Primera columna*/}
                        <div className="row">
                            <div className="col-12 col-md-6"><br></br>
                                {/* Motivo de cfdi relacionados */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend ">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Relación CFDI</span>
                                    </div>
                                    <select
                                        id="cartaRelaCFDI"
                                        className="form-control"
                                        disabled={(action === 2) && !editMode ? true : false}
                                        value={model?.MotivoRelacion ?? ""}
                                        onChange={(event) => this.ChangeMotivoRelacion(event.target.value)}
                                    >
                                        <option value=''>Seleccione una opción</option>
                                        <option value='00'>00 - No aplica</option>
                                        <option value='01'>01 - Nota de crédito de los document os relacionados</option>
                                        <option value='02'>02 - Nota de débito de los documentos relacionados</option>
                                        <option value='03'>03 - Devolución de mercancia sobre facturas o traslado</option>
                                        <option value='04'>04 - Sustitución de los CFDI previos</option>
                                        <option value='05'>05 - Traslado de mercancia facturados previamente</option>
                                        <option value='06'>06 - Factura generada por los traslados previos</option>
                                        <option value='07'>07 - CFDI por aplicación de anticipos</option>
                                    </select>
                                    <button type="button"
                                        className="input-group-text"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}

                                        onClick={() => this.GuideUser('cartaRelaCFDI')}>
                                        <i className="fa fa-info-circle" />
                                    </button>
                                </div>
                                {/*ParteTransporte*/}
                                {model.CFDI_Relacionados && model.CFDI_Relacionados.map((element, index) => {
                                    return (
                                        <div className="input-group mb-3">
                                            {/*Eliminar*/}
                                            {((action === 1 && editMode !== true) || (action === 2 && editMode)) &&
                                                <button
                                                    type="button"
                                                    style={{ backgroundColor: 'transparent', padding: 5, textAlign: "center", color: '#c42222' }}
                                                    className="btn"
                                                    onClick={() => this.DeleteCFDIByIndex(index)}
                                                >
                                                    <i className="fas fa-trash-alt"
                                                        aria-hidden="true" size="10" />
                                                </button>}
                                            <div className="input-group-prepend ">
                                                <span className="input-group-text font-weight-bold" id="basic-addon1">CFDI</span>
                                            </div>
                                            <input
                                                id={index}
                                                className="form-control btn-outline-secondary" type="text"
                                                value={element ?? ""}
                                                onChange={(event) => this.ChangeCFDIValueInArray(index, event.target.value)}
                                                disabled={action === 2 && !editMode}
                                                style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}>
                                            </input>
                                        </div>
                                    )
                                })
                                }

                            </div>

                            {/*Segunda columna*/}
                            <div className="col-12 col-md-6"><br></br>

                                {/*Añadir ParteTransporte*/}

                                <div className="input-group mb-3">
                                    <button type="button"
                                        className="btn botonCerrar text-white"
                                        disabled={(action === 2) && !editMode ? true : false}
                                        onClick={() => this.AddCFDIRelacionado()} >
                                        Añadir CFDI
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )
    }
    //#endregion

    render() {
        const { action, model, enableSpinner, showAlert, countries } = this.props;
        const { editMode, partners, partnerType, pageTotal, invoices, checkboxArray, modalView, itemModel, addressModel, flagAddressesPorteModal, states, municipios, localidades, colonias, ClaveProdByKey, addresses, outStockTransfersDocs, isCancelCFDI, showWarningModal, warningModel, selectAction, transportes, figurasTransporte, usoInterno, SAPSearch } = this.state;
        let dataList = [];
        switch (modalView) {
            case 'I':
                dataList = invoices;
                break;
            case 'outStockTransfersDocs':
                dataList = outStockTransfersDocs;
                break;
            case 'TransporteListModal':
                dataList = transportes;
                break;
            case 'FiguraTransporteListModal':
                dataList = figurasTransporte;
                break;
            default:
                dataList = partners;
                break;
        }

        return (
            <div className="modal fade bd-example-modal-lg modal-open scroll" id="CartaPorte" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">

                <CancelCFDI
                    CancelDocuments={this.CancelCFDI} />

                <ListPartnerModal
                    data={dataList}
                    modalView={modalView}
                    totalPage={pageTotal}
                    model={model}
                    cleanData={() => this.setState({ outStockTransfersDocs: [], partners: [], invoices: [], checkboxArray: (new Map()) })}
                    selectPartner={this.selectPartner}
                    type={partnerType}
                    selectItems={this.selectItems}
                    selectItemsToArray={this.selectItemsToArray}
                    checkboxArray={checkboxArray}
                    refreshPartner={this.refreshPartner}
                    showAlert={showAlert}
                    search={this.searchDocuments}
                    selectAction={selectAction} />

                <MercanciaPorteModal
                    model={model}
                    itemModel={itemModel}
                    refreshModel={this.refreshModel}

                    // Mercancias para uso interno
                    usoInterno={usoInterno}
                    OpenClaveProdSAT={this.OpenClaveProdSAT}
                />

                <ClaveProdModal
                    data={ClaveProdByKey}
                    SearchModalModel={this.state.SearchModalModel}
                    RefreshSearchModalModel={this.RefreshSearchModalModel}
                    CloseClaveProdModal={this.CloseClaveProdModal}
                    SearchBySearchModel={this.SearchBySearchModel}
                    SelectClaveProd={this.SelectClaveProd}
                    SAPSearch={SAPSearch}
                />

                {flagAddressesPorteModal && <>
                    <AddressesPorteModal
                        model={model}
                        enableSpinner={enableSpinner}
                        showAlert={showAlert}
                        addressModel={addressModel}
                        countries={countries}
                        action={action}
                        editMode={editMode}
                        states={states}
                        localidades={localidades}
                        colonias={colonias}
                        municipios={municipios}
                        flagAddressesPorteModal={flagAddressesPorteModal}
                        cleanData={() => this.setState({ flagAddressesPorteModal: false })}
                        refreshModel={this.refreshModel}
                        openAddresses={this.openAddresses}
                        getAddressesSAT={this.getCodigoPostalSAT}
                        getAddressDetailSAT={this.getAddressDetailSAT}
                    />

                    <AddressesPartnerModal
                        data={addresses}
                        selectAddresses={this.selectAddresses}
                        cleanData={() => this.setState({ addresses: [] })}
                    />
                </>}
                <div className="modal-dialog modal-lg modal-open" role="document">
                    <div className="modal-content">

                        <div className="modal-header text-white"
                            style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">DATOS DE LA CARTA PORTE</h4>
                            <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                <span className="text-white" aria-hidden="true">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div className="table-responsive">
                                            <table className="table response" style={{ marginBottom: 0 }}>
                                                {this.renderSelector()}
                                                {this.renderEditButton()}
                                                {/* {this.renderFieldsButton()} */}
                                                {/* <br /><br /> */}
                                                {this.renderPorteHeader()}
                                                {this.renderPorteBody()}<br></br><br></br>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            {/* NO BORRAR ESTO, YA ES SEMI FUNCIONAL Y ES HASTA GERARDO DIGA QUE SI SE LES PONE */}
                            {model.U_FMB_UUID && !editMode &&
                                <>
                                    {!isCancelCFDI ?
                                        <>
                                            <button
                                                type="button"
                                                className="btn btn-info text-white "
                                                style={{ position: "absolute", left: "1rem" }}
                                                onClick={() => this.ConsultarEstatusCFDI()}
                                            >
                                                Consultar estatus
                                            </button>
                                            {model.CanceledCFDI === 'Y' &&
                                                <button
                                                    type="button"
                                                    className="btn btn-info text-white "
                                                    href='https://verificacfdi.facturaelectronica.sat.gob.mx/'
                                                    // style={{ position: "absolute", left: "1rem" }}
                                                    onClick={() => this.OpenCFDI_SAT()}
                                                >
                                                    Consultar estatus CFDI-SAT
                                                </button>
                                            }

                                        </>
                                        :
                                        <button
                                            type="button"
                                            className="btn btn-danger text-white"
                                            style={{ position: "absolute", left: "1rem" }}
                                            onClick={this.OpenModalCancelCFDI}
                                        >
                                            Solicitar cancelación
                                        </button>
                                    }
                                </>
                            }
                            {/* {action !== 1 && !editMode && (
                                <button className="btn  btn-timbra-one btn-outline-secondary" onClick={() => this.billingInfo(9)} style={{ borderColor: "#A7A6A5" }}>
                                    <i className="fas fa-sync"></i> Timbrar
                                </button>
                            )} */}

                            {/* {action != 1 && !editMode && (
                                <button type="button" className="btn botonCerrar text-white" style={{ background: '#c42222 !important' }} onClick={this.deleteModel}>
                                    Eliminar
                                </button>
                            )} */}

                            <button type="button" className="btn botonCerrar text-white" onClick={this.closeModal}>Cerrar
                            </button>
                            {action === 1 &&
                                <button type="button" className="btn botonCorrect text-black" disabled={this.props?.disableButton}
                                    onClick={this.sendModel}> Crear</button>
                            }
                            {action === 2 && editMode && (
                                <>
                                    {/* Descomentar cuando se solicite la opcion de eliminar una carta porte
                                    <button type="button" className="btn btn-danger text-white" onClick={this.validateDeleteMode}>
                                        Eliminar
                                    </button> */}

                                    <button type="button" className="btn botonCorrect" onClick={this.acceptEditMode}>
                                        Guardar
                                    </button>

                                    <button type="button" className="btn botonCorrect" onClick={this.cancelEditMode}>
                                        Cancelar
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                </div>


                {showWarningModal && <WarningModal
                    title='Advertencia'
                    message={warningModel.message ?? ''}
                    btnAccept={warningModel.acceptMessage ?? ''}
                    btnCancel='Cancelar'
                    size='modal-lg'
                    accept={warningModel.acceptAction}
                    cancel={() => this.openCloseWarningModal(false)}
                />}
            </div>
        );
    }

    renderSelector = () => {
        const { model, action } = this.props;
        const { usoInterno, usoInternoAuthorized } = this.state;

        return (
            <>
                {(action === 1 && usoInternoAuthorized) &&
                    <div className="row">
                        <div className='col-6'>
                            <div className="form-group row" style={{ paddingLeft: 20 }}>
                                <div className="radio font-weight-bold" style={{ fontSize: 18, padding: 5 }}>
                                    <label>
                                        Uso Interno
                                    </label>
                                    <label className="switch ml-4" style={{ marginTop: "3px" }} >
                                        <input type="checkbox" checked={usoInterno} onChange={this.validateToCleanChanges} />
                                        <span className="sliderCO round"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>}
                <div className="row">
                    <div className='col-12 col-md-6'>
                        <div className="form-group row" style={{ paddingLeft: 20 }}>
                            <div className="radio font-weight-bold" style={{ fontSize: 18, padding: 5 }}>
                                <label>
                                    <span className="d-none d-xl-inline">Tipo de Documento</span>
                                    <span className="d-inline d-xl-none">Tipo Documento</span>
                                </label>
                            </div>
                            <select className="form-control" style={{ width: 'auto' }}
                                value={model?.TypeDoc ?? ''}
                                onChange={(event) => this.ChangeCartaPorteType(event.target.value)}
                                disabled={action === 2 ? true : false}
                            >
                                <option value={'I'}>Carta Porte - Factura(Ingreso)</option>
                                <option value={'T'}>Carta Porte - Traslado</option>
                            </select>
                        </div>
                    </div>
                    <div className='col-12 col-md-6'>
                        {model?.TypeDoc && model?.TypeDoc === 'T' && !usoInterno &&
                            <div className="form-group row" style={{ paddingLeft: 20 }}>
                                <div className="radio font-weight-bold" style={{ fontSize: 18, padding: 5 }}>
                                    <label>
                                        <span className="d-none d-xl-inline">Tipo de Traslado</span>
                                        <span className="d-inline d-xl-none">Tipo Traslado</span>
                                    </label>
                                </div>
                                <select className="form-control" style={{ width: 'auto' }}
                                    value={model?.SubTypeTransferDoc ?? ''}
                                    onChange={(event) => this.ChangeSubTypeTransferDoc(event.target.value)}
                                    disabled={action === 2 ? true : false}
                                >
                                    <option value={'S'}>Sucursal a Sucursal</option>
                                    <option value={'D'}>Traspasos directos</option>
                                    <option value={'C'}>CEDIS</option>
                                </select>
                            </div>
                        }
                    </div>

                </div>
            </>
        );
    };

    GuideUser = (buttonIdentifier) => {
        const { showAlert } = this.props;

        switch (buttonIdentifier) {
            case 'IdCCP':
                showAlert({ type: 'info', message: 'Este campo es generado por nosotros, es un ID en base RUT 4122 que identifica el complemento carta porte', timeOut: 10000 });
                break;
            case 'TranspInternac':
                showAlert({ type: 'info', message: 'Este campo indica si la mercancia sale o no del país', timeOut: 10000 });
                break;
            case 'cartaRelaCFDI':
                showAlert({ type: 'info', message: 'Este campo indica la relación de CFDI para los UUID que se colocan en la parte de abajo. Se puede usar para un re timbrando de este documento que estés editando o creando.', timeOut: 10000 });
                break;
            case 'TotalDistRec':
                showAlert({ type: 'info', message: 'La distancia total recorrida se calcula a partir de los datos ingresados en la sección de ubicaciones.', timeOut: 10000 });
                break;
            case 'TotalFlete':
                showAlert({ type: 'info', message: 'Total a cobrar por el flete de la mercancia. Esta campo se calcula por la sumatoria de los conceptos (Clave: 78101802) flete en los conceptos de manera automática', timeOut: 10000 });
                break;
            default:
                break;
        }


    }
}

export default CartaPorteModal;